// Generated by :audio-wire-codec-ksp — do not edit. See KLANG-00103 (worklet codec ksp).
@file:Suppress("unused", "UNUSED_PARAMETER", "RemoveRedundantQualifierName", "USELESS_CAST")

package io.peekandpoke.klang.audio_bridge.wire

/** Structural hash of the wire schema — frontend & worklet must agree (else a stale-build skew). */
const val WIRE_SCHEMA_HASH: Int = 210338569

fun encode_ScheduledVoice(v: io.peekandpoke.klang.audio_bridge.ScheduledVoice): dynamic = wireScoped {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.data = encode_VoiceData(v.data)
    o.startTime = v.startTime
    o.gateEndTime = v.gateEndTime
    o.playbackStartTime = v.playbackStartTime
    o
}

fun decode_ScheduledVoice(o: dynamic): io.peekandpoke.klang.audio_bridge.ScheduledVoice = wireScoped { io.peekandpoke.klang.audio_bridge.ScheduledVoice(
    playbackId = o.playbackId,
    data = decode_VoiceData(o.data),
    startTime = o.startTime,
    gateEndTime = o.gateEndTime,
    playbackStartTime = o.playbackStartTime,
)}

fun encode_VoiceData(v: io.peekandpoke.klang.audio_bridge.VoiceData): dynamic {
    val o: dynamic = wireObj()
    o.note = v.note
    o.freqHz = v.freqHz
    o.gain = v.gain
    o.legato = v.legato
    o.bank = v.bank
    o.sound = v.sound
    o.soundIndex = v.soundIndex
    o.ignitorParams = v.ignitorParams?.let { w0 -> wireEncodeStringDoubleMap(w0) }
    o.katalystParams = v.katalystParams?.let { w1 -> wireEncodeStringDoubleMap(w1) }
    o.cylinder = v.cylinder
    o.pan = v.pan
    o.cut = v.cut
    o.solo = v.solo
    o.sourceId = v.sourceId
    o.master = v.master
    o.katalyst = v.katalyst
    o.control = v.control
    o.tags = v.tags?.let { w3 -> wireEncodeSet(w3) { w2 -> w2 } }
    o.cull = v.cull
    return o
}

fun decode_VoiceData(o: dynamic): io.peekandpoke.klang.audio_bridge.VoiceData = io.peekandpoke.klang.audio_bridge.VoiceData(
    note = o.note,
    freqHz = o.freqHz,
    gain = o.gain,
    legato = o.legato,
    bank = o.bank,
    sound = o.sound,
    soundIndex = o.soundIndex,
    ignitorParams = if (o.ignitorParams != null) wireDecodeStringDoubleMap(o.ignitorParams) else null,
    katalystParams = if (o.katalystParams != null) wireDecodeStringDoubleMap(o.katalystParams) else null,
    cylinder = o.cylinder,
    pan = o.pan,
    cut = o.cut,
    solo = o.solo,
    sourceId = o.sourceId,
    master = o.master,
    katalyst = o.katalyst,
    control = o.control,
    tags = if (o.tags != null) wireDecodeSet(o.tags) { w4 -> w4 } else null,
    cull = o.cull,
)

fun encode_RealtimeVoice(v: io.peekandpoke.klang.audio_bridge.RealtimeVoice): dynamic = wireScoped {
    val o: dynamic = wireObj()
    o.liveId = v.liveId
    o.data = encode_VoiceData(v.data)
    o.gateDurSec = v.gateDurSec
    o
}

fun decode_RealtimeVoice(o: dynamic): io.peekandpoke.klang.audio_bridge.RealtimeVoice = wireScoped { io.peekandpoke.klang.audio_bridge.RealtimeVoice(
    liveId = o.liveId,
    data = decode_VoiceData(o.data),
    gateDurSec = o.gateDurSec,
)}

fun encode_KatalystDsl(v: io.peekandpoke.klang.audio_bridge.KatalystDsl): dynamic = wireScoped {
    val o: dynamic = wireObj()
    o.stages = wireEncodeList(v.stages) { w5 -> encode_KatalystStageDsl(w5) }
    o
}

fun decode_KatalystDsl(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystDsl = wireScoped { io.peekandpoke.klang.audio_bridge.KatalystDsl(
    stages = wireDecodeList(o.stages) { w6 -> decode_KatalystStageDsl(w6) },
)}

fun encode_KatalystStageDsl(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl): dynamic = wireScoped { when (v) {
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Abs -> { val o = wireObj(); o["#t"] = "abs"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Body -> { val o = encode_KatalystStageDsl_Body(v); o["#t"] = "body"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Compressor -> { val o = encode_KatalystStageDsl_Compressor(v); o["#t"] = "compressor"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Delay -> { val o = encode_KatalystStageDsl_Delay(v); o["#t"] = "delay"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Distort -> { val o = encode_KatalystStageDsl_Distort(v); o["#t"] = "distort"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Div -> { val o = encode_KatalystStageDsl_Div(v); o["#t"] = "div"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Duck -> { val o = encode_KatalystStageDsl_Duck(v); o["#t"] = "duck"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Eq -> { val o = encode_KatalystStageDsl_Eq(v); o["#t"] = "eq"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Gain -> { val o = encode_KatalystStageDsl_Gain(v); o["#t"] = "gain"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Max -> { val o = encode_KatalystStageDsl_Max(v); o["#t"] = "max"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Min -> { val o = encode_KatalystStageDsl_Min(v); o["#t"] = "min"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Minus -> { val o = encode_KatalystStageDsl_Minus(v); o["#t"] = "minus"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.OversampleAtLeast -> { val o = encode_KatalystStageDsl_OversampleAtLeast(v); o["#t"] = "oversampleAtLeast"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.OversampleBy -> { val o = encode_KatalystStageDsl_OversampleBy(v); o["#t"] = "oversampleBy"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Parallel -> { val o = encode_KatalystStageDsl_Parallel(v); o["#t"] = "parallel"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Phaser -> { val o = encode_KatalystStageDsl_Phaser(v); o["#t"] = "phaser"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Plus -> { val o = encode_KatalystStageDsl_Plus(v); o["#t"] = "plus"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Pow -> { val o = encode_KatalystStageDsl_Pow(v); o["#t"] = "pow"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Reverb -> { val o = encode_KatalystStageDsl_Reverb(v); o["#t"] = "reverb"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Times -> { val o = encode_KatalystStageDsl_Times(v); o["#t"] = "times"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Vowel -> { val o = encode_KatalystStageDsl_Vowel(v); o["#t"] = "vowel"; o }
}}

fun decode_KatalystStageDsl(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl = wireScoped { when (o["#t"].unsafeCast<String>()) {
    "abs" -> io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Abs
    "body" -> decode_KatalystStageDsl_Body(o)
    "compressor" -> decode_KatalystStageDsl_Compressor(o)
    "delay" -> decode_KatalystStageDsl_Delay(o)
    "distort" -> decode_KatalystStageDsl_Distort(o)
    "div" -> decode_KatalystStageDsl_Div(o)
    "duck" -> decode_KatalystStageDsl_Duck(o)
    "eq" -> decode_KatalystStageDsl_Eq(o)
    "gain" -> decode_KatalystStageDsl_Gain(o)
    "max" -> decode_KatalystStageDsl_Max(o)
    "min" -> decode_KatalystStageDsl_Min(o)
    "minus" -> decode_KatalystStageDsl_Minus(o)
    "oversampleAtLeast" -> decode_KatalystStageDsl_OversampleAtLeast(o)
    "oversampleBy" -> decode_KatalystStageDsl_OversampleBy(o)
    "parallel" -> decode_KatalystStageDsl_Parallel(o)
    "phaser" -> decode_KatalystStageDsl_Phaser(o)
    "plus" -> decode_KatalystStageDsl_Plus(o)
    "pow" -> decode_KatalystStageDsl_Pow(o)
    "reverb" -> decode_KatalystStageDsl_Reverb(o)
    "times" -> decode_KatalystStageDsl_Times(o)
    "vowel" -> decode_KatalystStageDsl_Vowel(o)
    else -> throw IllegalStateException("wire-codec: unknown KatalystStageDsl tag " + o["#t"])
}}

fun encode_KatalystStageDsl_Body(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Body): dynamic {
    val o: dynamic = wireObj()
    o.material = encode_KatalystKnobDsl(v.material)
    o.wet = encode_KatalystKnobDsl(v.wet)
    o.floor = encode_KatalystKnobDsl(v.floor)
    return o
}

fun decode_KatalystStageDsl_Body(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Body = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Body(
    material = decode_KatalystKnobDsl(o.material),
    wet = decode_KatalystKnobDsl(o.wet),
    floor = decode_KatalystKnobDsl(o.floor),
)

fun encode_KatalystKnobDsl(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl): dynamic = wireScoped { when (v) {
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Abs -> { val o = encode_KatalystKnobDsl_Abs(v); o["#t"] = "abs"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.BerlinNoise -> { val o = encode_KatalystKnobDsl_BerlinNoise(v); o["#t"] = "berlin-noise"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Constant -> { val o = encode_KatalystKnobDsl_Constant(v); o["#t"] = "const"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Div -> { val o = encode_KatalystKnobDsl_Div(v); o["#t"] = "div"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Max -> { val o = encode_KatalystKnobDsl_Max(v); o["#t"] = "max"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Min -> { val o = encode_KatalystKnobDsl_Min(v); o["#t"] = "min"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Minus -> { val o = encode_KatalystKnobDsl_Minus(v); o["#t"] = "minus"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Neg -> { val o = encode_KatalystKnobDsl_Neg(v); o["#t"] = "neg"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Param -> { val o = encode_KatalystKnobDsl_Param(v); o["#t"] = "param"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.PerlinNoise -> { val o = encode_KatalystKnobDsl_PerlinNoise(v); o["#t"] = "perlin-noise"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Plus -> { val o = encode_KatalystKnobDsl_Plus(v); o["#t"] = "plus"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Pow -> { val o = encode_KatalystKnobDsl_Pow(v); o["#t"] = "pow"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Ramp -> { val o = encode_KatalystKnobDsl_Ramp(v); o["#t"] = "ramp"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Range -> { val o = encode_KatalystKnobDsl_Range(v); o["#t"] = "range"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Saw -> { val o = encode_KatalystKnobDsl_Saw(v); o["#t"] = "saw"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Sine -> { val o = encode_KatalystKnobDsl_Sine(v); o["#t"] = "sine"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Square -> { val o = encode_KatalystKnobDsl_Square(v); o["#t"] = "square"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Times -> { val o = encode_KatalystKnobDsl_Times(v); o["#t"] = "times"; o }
    is io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Tri -> { val o = encode_KatalystKnobDsl_Tri(v); o["#t"] = "tri"; o }
}}

fun decode_KatalystKnobDsl(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl = wireScoped { when (o["#t"].unsafeCast<String>()) {
    "abs" -> decode_KatalystKnobDsl_Abs(o)
    "berlin-noise" -> decode_KatalystKnobDsl_BerlinNoise(o)
    "const" -> decode_KatalystKnobDsl_Constant(o)
    "div" -> decode_KatalystKnobDsl_Div(o)
    "max" -> decode_KatalystKnobDsl_Max(o)
    "min" -> decode_KatalystKnobDsl_Min(o)
    "minus" -> decode_KatalystKnobDsl_Minus(o)
    "neg" -> decode_KatalystKnobDsl_Neg(o)
    "param" -> decode_KatalystKnobDsl_Param(o)
    "perlin-noise" -> decode_KatalystKnobDsl_PerlinNoise(o)
    "plus" -> decode_KatalystKnobDsl_Plus(o)
    "pow" -> decode_KatalystKnobDsl_Pow(o)
    "ramp" -> decode_KatalystKnobDsl_Ramp(o)
    "range" -> decode_KatalystKnobDsl_Range(o)
    "saw" -> decode_KatalystKnobDsl_Saw(o)
    "sine" -> decode_KatalystKnobDsl_Sine(o)
    "square" -> decode_KatalystKnobDsl_Square(o)
    "times" -> decode_KatalystKnobDsl_Times(o)
    "tri" -> decode_KatalystKnobDsl_Tri(o)
    else -> throw IllegalStateException("wire-codec: unknown KatalystKnobDsl tag " + o["#t"])
}}

fun encode_KatalystKnobDsl_Abs(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Abs): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_KatalystKnobDsl(v.inner)
    return o
}

fun decode_KatalystKnobDsl_Abs(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Abs = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Abs(
    inner = decode_KatalystKnobDsl(o.inner),
)

fun encode_KatalystKnobDsl_BerlinNoise(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.BerlinNoise): dynamic {
    val o: dynamic = wireObj()
    o.rate = encode_KatalystKnobDsl(v.rate)
    o.octaves = encode_KatalystKnobDsl(v.octaves)
    o.persistence = encode_KatalystKnobDsl(v.persistence)
    return o
}

fun decode_KatalystKnobDsl_BerlinNoise(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.BerlinNoise = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.BerlinNoise(
    rate = decode_KatalystKnobDsl(o.rate),
    octaves = decode_KatalystKnobDsl(o.octaves),
    persistence = decode_KatalystKnobDsl(o.persistence),
)

fun encode_KatalystKnobDsl_Constant(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Constant): dynamic {
    val o: dynamic = wireObj()
    o.value = v.value
    return o
}

fun decode_KatalystKnobDsl_Constant(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Constant = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Constant(
    value = o.value,
)

fun encode_KatalystKnobDsl_Div(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Div): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_KatalystKnobDsl(v.left)
    o.right = encode_KatalystKnobDsl(v.right)
    return o
}

fun decode_KatalystKnobDsl_Div(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Div = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Div(
    left = decode_KatalystKnobDsl(o.left),
    right = decode_KatalystKnobDsl(o.right),
)

fun encode_KatalystKnobDsl_Max(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Max): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_KatalystKnobDsl(v.left)
    o.right = encode_KatalystKnobDsl(v.right)
    return o
}

fun decode_KatalystKnobDsl_Max(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Max = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Max(
    left = decode_KatalystKnobDsl(o.left),
    right = decode_KatalystKnobDsl(o.right),
)

fun encode_KatalystKnobDsl_Min(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Min): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_KatalystKnobDsl(v.left)
    o.right = encode_KatalystKnobDsl(v.right)
    return o
}

fun decode_KatalystKnobDsl_Min(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Min = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Min(
    left = decode_KatalystKnobDsl(o.left),
    right = decode_KatalystKnobDsl(o.right),
)

fun encode_KatalystKnobDsl_Minus(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Minus): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_KatalystKnobDsl(v.left)
    o.right = encode_KatalystKnobDsl(v.right)
    return o
}

fun decode_KatalystKnobDsl_Minus(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Minus = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Minus(
    left = decode_KatalystKnobDsl(o.left),
    right = decode_KatalystKnobDsl(o.right),
)

fun encode_KatalystKnobDsl_Neg(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Neg): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_KatalystKnobDsl(v.inner)
    return o
}

fun decode_KatalystKnobDsl_Neg(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Neg = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Neg(
    inner = decode_KatalystKnobDsl(o.inner),
)

fun encode_KatalystKnobDsl_Param(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Param): dynamic {
    val o: dynamic = wireObj()
    o.name = v.name
    o.default = v.default
    o.description = v.description
    return o
}

fun decode_KatalystKnobDsl_Param(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Param = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Param(
    name = o.name,
    default = o.default,
    description = o.description,
)

fun encode_KatalystKnobDsl_PerlinNoise(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.PerlinNoise): dynamic {
    val o: dynamic = wireObj()
    o.rate = encode_KatalystKnobDsl(v.rate)
    o.octaves = encode_KatalystKnobDsl(v.octaves)
    o.persistence = encode_KatalystKnobDsl(v.persistence)
    return o
}

fun decode_KatalystKnobDsl_PerlinNoise(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.PerlinNoise = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.PerlinNoise(
    rate = decode_KatalystKnobDsl(o.rate),
    octaves = decode_KatalystKnobDsl(o.octaves),
    persistence = decode_KatalystKnobDsl(o.persistence),
)

fun encode_KatalystKnobDsl_Plus(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Plus): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_KatalystKnobDsl(v.left)
    o.right = encode_KatalystKnobDsl(v.right)
    return o
}

fun decode_KatalystKnobDsl_Plus(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Plus = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Plus(
    left = decode_KatalystKnobDsl(o.left),
    right = decode_KatalystKnobDsl(o.right),
)

fun encode_KatalystKnobDsl_Pow(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Pow): dynamic {
    val o: dynamic = wireObj()
    o.base = encode_KatalystKnobDsl(v.base)
    o.exp = encode_KatalystKnobDsl(v.exp)
    return o
}

fun decode_KatalystKnobDsl_Pow(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Pow = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Pow(
    base = decode_KatalystKnobDsl(o.base),
    exp = decode_KatalystKnobDsl(o.exp),
)

fun encode_KatalystKnobDsl_Ramp(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Ramp): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_KatalystKnobDsl(v.freq)
    o.phase = encode_KatalystKnobDsl(v.phase)
    return o
}

fun decode_KatalystKnobDsl_Ramp(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Ramp = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Ramp(
    freq = decode_KatalystKnobDsl(o.freq),
    phase = decode_KatalystKnobDsl(o.phase),
)

fun encode_KatalystKnobDsl_Range(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Range): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_KatalystKnobDsl(v.inner)
    o.from = encode_KatalystKnobDsl(v.from)
    o.to = encode_KatalystKnobDsl(v.to)
    return o
}

fun decode_KatalystKnobDsl_Range(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Range = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Range(
    inner = decode_KatalystKnobDsl(o.inner),
    from = decode_KatalystKnobDsl(o.from),
    to = decode_KatalystKnobDsl(o.to),
)

fun encode_KatalystKnobDsl_Saw(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Saw): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_KatalystKnobDsl(v.freq)
    o.phase = encode_KatalystKnobDsl(v.phase)
    return o
}

fun decode_KatalystKnobDsl_Saw(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Saw = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Saw(
    freq = decode_KatalystKnobDsl(o.freq),
    phase = decode_KatalystKnobDsl(o.phase),
)

fun encode_KatalystKnobDsl_Sine(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Sine): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_KatalystKnobDsl(v.freq)
    o.phase = encode_KatalystKnobDsl(v.phase)
    return o
}

fun decode_KatalystKnobDsl_Sine(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Sine = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Sine(
    freq = decode_KatalystKnobDsl(o.freq),
    phase = decode_KatalystKnobDsl(o.phase),
)

fun encode_KatalystKnobDsl_Square(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Square): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_KatalystKnobDsl(v.freq)
    o.duty = encode_KatalystKnobDsl(v.duty)
    o.phase = encode_KatalystKnobDsl(v.phase)
    return o
}

fun decode_KatalystKnobDsl_Square(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Square = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Square(
    freq = decode_KatalystKnobDsl(o.freq),
    duty = decode_KatalystKnobDsl(o.duty),
    phase = decode_KatalystKnobDsl(o.phase),
)

fun encode_KatalystKnobDsl_Times(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Times): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_KatalystKnobDsl(v.left)
    o.right = encode_KatalystKnobDsl(v.right)
    return o
}

fun decode_KatalystKnobDsl_Times(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Times = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Times(
    left = decode_KatalystKnobDsl(o.left),
    right = decode_KatalystKnobDsl(o.right),
)

fun encode_KatalystKnobDsl_Tri(v: io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Tri): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_KatalystKnobDsl(v.freq)
    o.phase = encode_KatalystKnobDsl(v.phase)
    return o
}

fun decode_KatalystKnobDsl_Tri(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Tri = io.peekandpoke.klang.audio_bridge.KatalystKnobDsl.Tri(
    freq = decode_KatalystKnobDsl(o.freq),
    phase = decode_KatalystKnobDsl(o.phase),
)

fun encode_KatalystStageDsl_Compressor(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Compressor): dynamic {
    val o: dynamic = wireObj()
    o.threshold = encode_KatalystKnobDsl(v.threshold)
    o.ratio = encode_KatalystKnobDsl(v.ratio)
    o.knee = encode_KatalystKnobDsl(v.knee)
    o.attack = encode_KatalystKnobDsl(v.attack)
    o.release = encode_KatalystKnobDsl(v.release)
    o.lookahead = v.lookahead
    return o
}

fun decode_KatalystStageDsl_Compressor(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Compressor = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Compressor(
    threshold = decode_KatalystKnobDsl(o.threshold),
    ratio = decode_KatalystKnobDsl(o.ratio),
    knee = decode_KatalystKnobDsl(o.knee),
    attack = decode_KatalystKnobDsl(o.attack),
    release = decode_KatalystKnobDsl(o.release),
    lookahead = o.lookahead,
)

fun encode_KatalystStageDsl_Delay(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Delay): dynamic {
    val o: dynamic = wireObj()
    o.wet = encode_KatalystKnobDsl(v.wet)
    o.time = encode_KatalystKnobDsl(v.time)
    o.feedback = encode_KatalystKnobDsl(v.feedback)
    o.cap = encode_KatalystKnobDsl(v.cap)
    return o
}

fun decode_KatalystStageDsl_Delay(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Delay = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Delay(
    wet = decode_KatalystKnobDsl(o.wet),
    time = decode_KatalystKnobDsl(o.time),
    feedback = decode_KatalystKnobDsl(o.feedback),
    cap = decode_KatalystKnobDsl(o.cap),
)

fun encode_KatalystStageDsl_Distort(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Distort): dynamic {
    val o: dynamic = wireObj()
    o.amount = encode_KatalystKnobDsl(v.amount)
    o.shape = v.shape
    return o
}

fun decode_KatalystStageDsl_Distort(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Distort = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Distort(
    amount = decode_KatalystKnobDsl(o.amount),
    shape = o.shape,
)

fun encode_KatalystStageDsl_Div(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Div): dynamic {
    val o: dynamic = wireObj()
    o.other = encode_KatalystKnobDsl(v.other)
    return o
}

fun decode_KatalystStageDsl_Div(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Div = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Div(
    other = decode_KatalystKnobDsl(o.other),
)

fun encode_KatalystStageDsl_Duck(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Duck): dynamic {
    val o: dynamic = wireObj()
    o.orbit = encode_KatalystKnobDsl(v.orbit)
    o.depth = encode_KatalystKnobDsl(v.depth)
    o.attack = encode_KatalystKnobDsl(v.attack)
    return o
}

fun decode_KatalystStageDsl_Duck(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Duck = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Duck(
    orbit = decode_KatalystKnobDsl(o.orbit),
    depth = decode_KatalystKnobDsl(o.depth),
    attack = decode_KatalystKnobDsl(o.attack),
)

fun encode_KatalystStageDsl_Eq(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Eq): dynamic {
    val o: dynamic = wireObj()
    o.sections = wireEncodeList(v.sections) { w7 -> encode_IgnitorDsl_EqSection(w7) }
    return o
}

fun decode_KatalystStageDsl_Eq(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Eq = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Eq(
    sections = wireDecodeList(o.sections) { w8 -> decode_IgnitorDsl_EqSection(w8) },
)

fun encode_IgnitorDsl_EqSection(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection): dynamic = wireScoped { when (v) {
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Bandpass -> { val o = encode_IgnitorDsl_EqSection_Bandpass(v); o["#t"] = "eqBandpass"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Bell -> { val o = encode_IgnitorDsl_EqSection_Bell(v); o["#t"] = "eqBell"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Highpass -> { val o = encode_IgnitorDsl_EqSection_Highpass(v); o["#t"] = "eqHighpass"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Lowpass -> { val o = encode_IgnitorDsl_EqSection_Lowpass(v); o["#t"] = "eqLowpass"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Notch -> { val o = encode_IgnitorDsl_EqSection_Notch(v); o["#t"] = "eqNotch"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.RawTap -> { val o = encode_IgnitorDsl_EqSection_RawTap(v); o["#t"] = "eqRawTap"; o }
}}

fun decode_IgnitorDsl_EqSection(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection = wireScoped { when (o["#t"].unsafeCast<String>()) {
    "eqBandpass" -> decode_IgnitorDsl_EqSection_Bandpass(o)
    "eqBell" -> decode_IgnitorDsl_EqSection_Bell(o)
    "eqHighpass" -> decode_IgnitorDsl_EqSection_Highpass(o)
    "eqLowpass" -> decode_IgnitorDsl_EqSection_Lowpass(o)
    "eqNotch" -> decode_IgnitorDsl_EqSection_Notch(o)
    "eqRawTap" -> decode_IgnitorDsl_EqSection_RawTap(o)
    else -> throw IllegalStateException("wire-codec: unknown IgnitorDsl_EqSection tag " + o["#t"])
}}

fun encode_IgnitorDsl_EqSection_Bandpass(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Bandpass): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.q = encode_IgnitorDsl(v.q)
    return o
}

fun decode_IgnitorDsl_EqSection_Bandpass(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Bandpass = io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Bandpass(
    freq = decode_IgnitorDsl(o.freq),
    q = decode_IgnitorDsl(o.q),
)

fun encode_IgnitorDsl(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl): dynamic = wireScoped { wireEncodeShared(v) { when (v) {
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Abs -> { val o = encode_IgnitorDsl_Abs(v); o["#t"] = "abs"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Accelerate -> { val o = encode_IgnitorDsl_Accelerate(v); o["#t"] = "accelerate"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Adsr -> { val o = encode_IgnitorDsl_Adsr(v); o["#t"] = "adsr"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Affine -> { val o = encode_IgnitorDsl_Affine(v); o["#t"] = "affine"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Bandpass -> { val o = encode_IgnitorDsl_Bandpass(v); o["#t"] = "bandpass"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.BerlinNoise -> { val o = encode_IgnitorDsl_BerlinNoise(v); o["#t"] = "berlin-noise"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.BrownNoise -> { val o = encode_IgnitorDsl_BrownNoise(v); o["#t"] = "brown-noise"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Ceil -> { val o = encode_IgnitorDsl_Ceil(v); o["#t"] = "ceil"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Clamp -> { val o = encode_IgnitorDsl_Clamp(v); o["#t"] = "clamp"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Coarse -> { val o = encode_IgnitorDsl_Coarse(v); o["#t"] = "coarse"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Constant -> { val o = encode_IgnitorDsl_Constant(v); o["#t"] = "const"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Crackle -> { val o = encode_IgnitorDsl_Crackle(v); o["#t"] = "crackle"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Crush -> { val o = encode_IgnitorDsl_Crush(v); o["#t"] = "crush"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Detune -> { val o = encode_IgnitorDsl_Detune(v); o["#t"] = "detune"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Distort -> { val o = encode_IgnitorDsl_Distort(v); o["#t"] = "distort"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Div -> { val o = encode_IgnitorDsl_Div(v); o["#t"] = "div"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Drive -> { val o = encode_IgnitorDsl_Drive(v); o["#t"] = "drive"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Dust -> { val o = encode_IgnitorDsl_Dust(v); o["#t"] = "dust"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Eq -> { val o = encode_IgnitorDsl_Eq(v); o["#t"] = "eq"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Exp -> { val o = encode_IgnitorDsl_Exp(v); o["#t"] = "exp"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Floor -> { val o = encode_IgnitorDsl_Floor(v); o["#t"] = "floor"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Fm -> { val o = encode_IgnitorDsl_Fm(v); o["#t"] = "fm"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Frac -> { val o = encode_IgnitorDsl_Frac(v); o["#t"] = "frac"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Freq -> { val o = wireObj(); o["#t"] = "freq"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Highpass -> { val o = encode_IgnitorDsl_Highpass(v); o["#t"] = "highpass"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Impulse -> { val o = encode_IgnitorDsl_Impulse(v); o["#t"] = "impulse"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Lerp -> { val o = encode_IgnitorDsl_Lerp(v); o["#t"] = "lerp"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Log -> { val o = encode_IgnitorDsl_Log(v); o["#t"] = "log"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Lowpass -> { val o = encode_IgnitorDsl_Lowpass(v); o["#t"] = "lowpass"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Max -> { val o = encode_IgnitorDsl_Max(v); o["#t"] = "max"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Min -> { val o = encode_IgnitorDsl_Min(v); o["#t"] = "min"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Minus -> { val o = encode_IgnitorDsl_Minus(v); o["#t"] = "minus"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Mod -> { val o = encode_IgnitorDsl_Mod(v); o["#t"] = "mod"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Neg -> { val o = encode_IgnitorDsl_Neg(v); o["#t"] = "neg"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Notch -> { val o = encode_IgnitorDsl_Notch(v); o["#t"] = "notch"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.OnePoleLowpass -> { val o = encode_IgnitorDsl_OnePoleLowpass(v); o["#t"] = "one-pole-lowpass"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.OptimizerHint -> { val o = encode_IgnitorDsl_OptimizerHint(v); o["#t"] = "optimizerHint"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.OversampleAtLeast -> { val o = encode_IgnitorDsl_OversampleAtLeast(v); o["#t"] = "oversampleAtLeast"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.OversampleBy -> { val o = encode_IgnitorDsl_OversampleBy(v); o["#t"] = "oversampleBy"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Parallel -> { val o = encode_IgnitorDsl_Parallel(v); o["#t"] = "parallel"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Param -> { val o = encode_IgnitorDsl_Param(v); o["#t"] = "param"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.PerlinNoise -> { val o = encode_IgnitorDsl_PerlinNoise(v); o["#t"] = "perlin-noise"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Phaser -> { val o = encode_IgnitorDsl_Phaser(v); o["#t"] = "phaser"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.PinkNoise -> { val o = encode_IgnitorDsl_PinkNoise(v); o["#t"] = "pink-noise"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.PitchEnvelope -> { val o = encode_IgnitorDsl_PitchEnvelope(v); o["#t"] = "pitch-envelope"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.PitchMod -> { val o = encode_IgnitorDsl_PitchMod(v); o["#t"] = "pitch-mod"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.PitchModSemitones -> { val o = encode_IgnitorDsl_PitchModSemitones(v); o["#t"] = "pitch-mod-semitones"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Pluck -> { val o = encode_IgnitorDsl_Pluck(v); o["#t"] = "pluck"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Plus -> { val o = encode_IgnitorDsl_Plus(v); o["#t"] = "plus"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Pow -> { val o = encode_IgnitorDsl_Pow(v); o["#t"] = "pow"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Pulze -> { val o = encode_IgnitorDsl_Pulze(v); o["#t"] = "pulze"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Ramp -> { val o = encode_IgnitorDsl_Ramp(v); o["#t"] = "ramp"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Range -> { val o = encode_IgnitorDsl_Range(v); o["#t"] = "range"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.RawPulze -> { val o = encode_IgnitorDsl_RawPulze(v); o["#t"] = "raw-pulze"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Recip -> { val o = encode_IgnitorDsl_Recip(v); o["#t"] = "recip"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.RegionInput -> { val o = encode_IgnitorDsl_RegionInput(v); o["#t"] = "regionInput"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Round -> { val o = encode_IgnitorDsl_Round(v); o["#t"] = "round"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sample -> { val o = wireObj(); o["#t"] = "sample"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Saw -> { val o = encode_IgnitorDsl_Saw(v); o["#t"] = "saw"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Select -> { val o = encode_IgnitorDsl_Select(v); o["#t"] = "select"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Shape -> { val o = encode_IgnitorDsl_Shape(v); o["#t"] = "shape"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Shimmer -> { val o = encode_IgnitorDsl_Shimmer(v); o["#t"] = "shimmer"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sign -> { val o = encode_IgnitorDsl_Sign(v); o["#t"] = "sign"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Silence -> { val o = wireObj(); o["#t"] = "silence"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sine -> { val o = encode_IgnitorDsl_Sine(v); o["#t"] = "sine"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sq -> { val o = encode_IgnitorDsl_Sq(v); o["#t"] = "sq"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sqrt -> { val o = encode_IgnitorDsl_Sqrt(v); o["#t"] = "sqrt"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Square -> { val o = encode_IgnitorDsl_Square(v); o["#t"] = "square"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperPluck -> { val o = encode_IgnitorDsl_SuperPluck(v); o["#t"] = "superpluck"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperRamp -> { val o = encode_IgnitorDsl_SuperRamp(v); o["#t"] = "superramp"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperSaw -> { val o = encode_IgnitorDsl_SuperSaw(v); o["#t"] = "supersaw"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperSine -> { val o = encode_IgnitorDsl_SuperSine(v); o["#t"] = "supersine"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperSquare -> { val o = encode_IgnitorDsl_SuperSquare(v); o["#t"] = "supersquare"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperTri -> { val o = encode_IgnitorDsl_SuperTri(v); o["#t"] = "supertri"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Tanh -> { val o = encode_IgnitorDsl_Tanh(v); o["#t"] = "tanh"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Times -> { val o = encode_IgnitorDsl_Times(v); o["#t"] = "times"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Tremolo -> { val o = encode_IgnitorDsl_Tremolo(v); o["#t"] = "tremolo"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Tri -> { val o = encode_IgnitorDsl_Tri(v); o["#t"] = "tri"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Variants -> { val o = encode_IgnitorDsl_Variants(v); o["#t"] = "variants"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Vibrato -> { val o = encode_IgnitorDsl_Vibrato(v); o["#t"] = "vibrato"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.WhiteNoise -> { val o = encode_IgnitorDsl_WhiteNoise(v); o["#t"] = "white-noise"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Zamp -> { val o = encode_IgnitorDsl_Zamp(v); o["#t"] = "zamp"; o }
    is io.peekandpoke.klang.audio_bridge.IgnitorDsl.Zawtooth -> { val o = encode_IgnitorDsl_Zawtooth(v); o["#t"] = "zawtooth"; o }
}}}

fun decode_IgnitorDsl(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl = wireScoped { wireDecodeShared(o) { when (o["#t"].unsafeCast<String>()) {
    "abs" -> decode_IgnitorDsl_Abs(o)
    "accelerate" -> decode_IgnitorDsl_Accelerate(o)
    "adsr" -> decode_IgnitorDsl_Adsr(o)
    "affine" -> decode_IgnitorDsl_Affine(o)
    "bandpass" -> decode_IgnitorDsl_Bandpass(o)
    "berlin-noise" -> decode_IgnitorDsl_BerlinNoise(o)
    "brown-noise" -> decode_IgnitorDsl_BrownNoise(o)
    "ceil" -> decode_IgnitorDsl_Ceil(o)
    "clamp" -> decode_IgnitorDsl_Clamp(o)
    "coarse" -> decode_IgnitorDsl_Coarse(o)
    "const" -> decode_IgnitorDsl_Constant(o)
    "crackle" -> decode_IgnitorDsl_Crackle(o)
    "crush" -> decode_IgnitorDsl_Crush(o)
    "detune" -> decode_IgnitorDsl_Detune(o)
    "distort" -> decode_IgnitorDsl_Distort(o)
    "div" -> decode_IgnitorDsl_Div(o)
    "drive" -> decode_IgnitorDsl_Drive(o)
    "dust" -> decode_IgnitorDsl_Dust(o)
    "eq" -> decode_IgnitorDsl_Eq(o)
    "exp" -> decode_IgnitorDsl_Exp(o)
    "floor" -> decode_IgnitorDsl_Floor(o)
    "fm" -> decode_IgnitorDsl_Fm(o)
    "frac" -> decode_IgnitorDsl_Frac(o)
    "freq" -> io.peekandpoke.klang.audio_bridge.IgnitorDsl.Freq
    "highpass" -> decode_IgnitorDsl_Highpass(o)
    "impulse" -> decode_IgnitorDsl_Impulse(o)
    "lerp" -> decode_IgnitorDsl_Lerp(o)
    "log" -> decode_IgnitorDsl_Log(o)
    "lowpass" -> decode_IgnitorDsl_Lowpass(o)
    "max" -> decode_IgnitorDsl_Max(o)
    "min" -> decode_IgnitorDsl_Min(o)
    "minus" -> decode_IgnitorDsl_Minus(o)
    "mod" -> decode_IgnitorDsl_Mod(o)
    "neg" -> decode_IgnitorDsl_Neg(o)
    "notch" -> decode_IgnitorDsl_Notch(o)
    "one-pole-lowpass" -> decode_IgnitorDsl_OnePoleLowpass(o)
    "optimizerHint" -> decode_IgnitorDsl_OptimizerHint(o)
    "oversampleAtLeast" -> decode_IgnitorDsl_OversampleAtLeast(o)
    "oversampleBy" -> decode_IgnitorDsl_OversampleBy(o)
    "parallel" -> decode_IgnitorDsl_Parallel(o)
    "param" -> decode_IgnitorDsl_Param(o)
    "perlin-noise" -> decode_IgnitorDsl_PerlinNoise(o)
    "phaser" -> decode_IgnitorDsl_Phaser(o)
    "pink-noise" -> decode_IgnitorDsl_PinkNoise(o)
    "pitch-envelope" -> decode_IgnitorDsl_PitchEnvelope(o)
    "pitch-mod" -> decode_IgnitorDsl_PitchMod(o)
    "pitch-mod-semitones" -> decode_IgnitorDsl_PitchModSemitones(o)
    "pluck" -> decode_IgnitorDsl_Pluck(o)
    "plus" -> decode_IgnitorDsl_Plus(o)
    "pow" -> decode_IgnitorDsl_Pow(o)
    "pulze" -> decode_IgnitorDsl_Pulze(o)
    "ramp" -> decode_IgnitorDsl_Ramp(o)
    "range" -> decode_IgnitorDsl_Range(o)
    "raw-pulze" -> decode_IgnitorDsl_RawPulze(o)
    "recip" -> decode_IgnitorDsl_Recip(o)
    "regionInput" -> decode_IgnitorDsl_RegionInput(o)
    "round" -> decode_IgnitorDsl_Round(o)
    "sample" -> io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sample
    "saw" -> decode_IgnitorDsl_Saw(o)
    "select" -> decode_IgnitorDsl_Select(o)
    "shape" -> decode_IgnitorDsl_Shape(o)
    "shimmer" -> decode_IgnitorDsl_Shimmer(o)
    "sign" -> decode_IgnitorDsl_Sign(o)
    "silence" -> io.peekandpoke.klang.audio_bridge.IgnitorDsl.Silence
    "sine" -> decode_IgnitorDsl_Sine(o)
    "sq" -> decode_IgnitorDsl_Sq(o)
    "sqrt" -> decode_IgnitorDsl_Sqrt(o)
    "square" -> decode_IgnitorDsl_Square(o)
    "superpluck" -> decode_IgnitorDsl_SuperPluck(o)
    "superramp" -> decode_IgnitorDsl_SuperRamp(o)
    "supersaw" -> decode_IgnitorDsl_SuperSaw(o)
    "supersine" -> decode_IgnitorDsl_SuperSine(o)
    "supersquare" -> decode_IgnitorDsl_SuperSquare(o)
    "supertri" -> decode_IgnitorDsl_SuperTri(o)
    "tanh" -> decode_IgnitorDsl_Tanh(o)
    "times" -> decode_IgnitorDsl_Times(o)
    "tremolo" -> decode_IgnitorDsl_Tremolo(o)
    "tri" -> decode_IgnitorDsl_Tri(o)
    "variants" -> decode_IgnitorDsl_Variants(o)
    "vibrato" -> decode_IgnitorDsl_Vibrato(o)
    "white-noise" -> decode_IgnitorDsl_WhiteNoise(o)
    "zamp" -> decode_IgnitorDsl_Zamp(o)
    "zawtooth" -> decode_IgnitorDsl_Zawtooth(o)
    else -> throw IllegalStateException("wire-codec: unknown IgnitorDsl tag " + o["#t"])
}}}

fun encode_IgnitorDsl_Abs(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Abs): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Abs(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Abs = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Abs(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_Accelerate(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Accelerate): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.semitones = encode_IgnitorDsl(v.semitones)
    return o
}

fun decode_IgnitorDsl_Accelerate(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Accelerate = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Accelerate(
    inner = decode_IgnitorDsl(o.inner),
    semitones = decode_IgnitorDsl(o.semitones),
)

fun encode_IgnitorDsl_Adsr(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Adsr): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.attack = encode_IgnitorDsl(v.attack)
    o.decay = encode_IgnitorDsl(v.decay)
    o.sustain = encode_IgnitorDsl(v.sustain)
    o.release = encode_IgnitorDsl(v.release)
    o.attackCurve = encode_IgnitorDsl(v.attackCurve)
    o.decayCurve = encode_IgnitorDsl(v.decayCurve)
    o.releaseCurve = encode_IgnitorDsl(v.releaseCurve)
    o.declick = encode_IgnitorDsl(v.declick)
    o.on = encode_IgnitorDsl(v.on)
    return o
}

fun decode_IgnitorDsl_Adsr(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Adsr = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Adsr(
    inner = decode_IgnitorDsl(o.inner),
    attack = decode_IgnitorDsl(o.attack),
    decay = decode_IgnitorDsl(o.decay),
    sustain = decode_IgnitorDsl(o.sustain),
    release = decode_IgnitorDsl(o.release),
    attackCurve = decode_IgnitorDsl(o.attackCurve),
    decayCurve = decode_IgnitorDsl(o.decayCurve),
    releaseCurve = decode_IgnitorDsl(o.releaseCurve),
    declick = decode_IgnitorDsl(o.declick),
    on = decode_IgnitorDsl(o.on),
)

fun encode_IgnitorDsl_Affine(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Affine): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.pre = encode_IgnitorDsl(v.pre)
    o.mul = encode_IgnitorDsl(v.mul)
    o.add = encode_IgnitorDsl(v.add)
    return o
}

fun decode_IgnitorDsl_Affine(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Affine = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Affine(
    inner = decode_IgnitorDsl(o.inner),
    pre = decode_IgnitorDsl(o.pre),
    mul = decode_IgnitorDsl(o.mul),
    add = decode_IgnitorDsl(o.add),
)

fun encode_IgnitorDsl_Bandpass(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Bandpass): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.freq = encode_IgnitorDsl(v.freq)
    o.q = encode_IgnitorDsl(v.q)
    o.analog = encode_IgnitorDsl(v.analog)
    o.env = encode_IgnitorDsl(v.env)
    o.attack = encode_IgnitorDsl(v.attack)
    o.decay = encode_IgnitorDsl(v.decay)
    o.sustain = encode_IgnitorDsl(v.sustain)
    o.release = encode_IgnitorDsl(v.release)
    o.attackCurve = encode_IgnitorDsl(v.attackCurve)
    o.decayCurve = encode_IgnitorDsl(v.decayCurve)
    o.releaseCurve = encode_IgnitorDsl(v.releaseCurve)
    o.humanize = v.humanize
    return o
}

fun decode_IgnitorDsl_Bandpass(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Bandpass = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Bandpass(
    inner = decode_IgnitorDsl(o.inner),
    freq = decode_IgnitorDsl(o.freq),
    q = decode_IgnitorDsl(o.q),
    analog = decode_IgnitorDsl(o.analog),
    env = decode_IgnitorDsl(o.env),
    attack = decode_IgnitorDsl(o.attack),
    decay = decode_IgnitorDsl(o.decay),
    sustain = decode_IgnitorDsl(o.sustain),
    release = decode_IgnitorDsl(o.release),
    attackCurve = decode_IgnitorDsl(o.attackCurve),
    decayCurve = decode_IgnitorDsl(o.decayCurve),
    releaseCurve = decode_IgnitorDsl(o.releaseCurve),
    humanize = o.humanize,
)

fun encode_IgnitorDsl_BerlinNoise(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.BerlinNoise): dynamic {
    val o: dynamic = wireObj()
    o.rate = encode_IgnitorDsl(v.rate)
    o.octaves = encode_IgnitorDsl(v.octaves)
    o.persistence = encode_IgnitorDsl(v.persistence)
    return o
}

fun decode_IgnitorDsl_BerlinNoise(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.BerlinNoise = io.peekandpoke.klang.audio_bridge.IgnitorDsl.BerlinNoise(
    rate = decode_IgnitorDsl(o.rate),
    octaves = decode_IgnitorDsl(o.octaves),
    persistence = decode_IgnitorDsl(o.persistence),
)

fun encode_IgnitorDsl_BrownNoise(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.BrownNoise): dynamic {
    val o: dynamic = wireObj()
    o.leak = encode_IgnitorDsl(v.leak)
    o.uid = v.uid
    return o
}

fun decode_IgnitorDsl_BrownNoise(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.BrownNoise = io.peekandpoke.klang.audio_bridge.IgnitorDsl.BrownNoise(
    leak = decode_IgnitorDsl(o.leak),
    uid = o.uid,
)

fun encode_IgnitorDsl_Ceil(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Ceil): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Ceil(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Ceil = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Ceil(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_Clamp(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Clamp): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.lo = encode_IgnitorDsl(v.lo)
    o.hi = encode_IgnitorDsl(v.hi)
    return o
}

fun decode_IgnitorDsl_Clamp(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Clamp = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Clamp(
    inner = decode_IgnitorDsl(o.inner),
    lo = decode_IgnitorDsl(o.lo),
    hi = decode_IgnitorDsl(o.hi),
)

fun encode_IgnitorDsl_Coarse(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Coarse): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.factor = encode_IgnitorDsl(v.factor)
    return o
}

fun decode_IgnitorDsl_Coarse(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Coarse = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Coarse(
    inner = decode_IgnitorDsl(o.inner),
    factor = decode_IgnitorDsl(o.factor),
)

fun encode_IgnitorDsl_Constant(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Constant): dynamic {
    val o: dynamic = wireObj()
    o.value = v.value
    return o
}

fun decode_IgnitorDsl_Constant(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Constant = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Constant(
    value = o.value,
)

fun encode_IgnitorDsl_Crackle(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Crackle): dynamic {
    val o: dynamic = wireObj()
    o.chaos = encode_IgnitorDsl(v.chaos)
    return o
}

fun decode_IgnitorDsl_Crackle(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Crackle = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Crackle(
    chaos = decode_IgnitorDsl(o.chaos),
)

fun encode_IgnitorDsl_Crush(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Crush): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.bits = encode_IgnitorDsl(v.bits)
    return o
}

fun decode_IgnitorDsl_Crush(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Crush = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Crush(
    inner = decode_IgnitorDsl(o.inner),
    bits = decode_IgnitorDsl(o.bits),
)

fun encode_IgnitorDsl_Detune(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Detune): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.semitones = encode_IgnitorDsl(v.semitones)
    return o
}

fun decode_IgnitorDsl_Detune(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Detune = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Detune(
    inner = decode_IgnitorDsl(o.inner),
    semitones = decode_IgnitorDsl(o.semitones),
)

fun encode_IgnitorDsl_Distort(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Distort): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.amount = encode_IgnitorDsl(v.amount)
    o.shape = encode_IgnitorDsl(v.shape)
    return o
}

fun decode_IgnitorDsl_Distort(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Distort = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Distort(
    inner = decode_IgnitorDsl(o.inner),
    amount = decode_IgnitorDsl(o.amount),
    shape = decode_IgnitorDsl(o.shape),
)

fun encode_IgnitorDsl_Div(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Div): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_IgnitorDsl(v.left)
    o.right = encode_IgnitorDsl(v.right)
    return o
}

fun decode_IgnitorDsl_Div(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Div = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Div(
    left = decode_IgnitorDsl(o.left),
    right = decode_IgnitorDsl(o.right),
)

fun encode_IgnitorDsl_Drive(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Drive): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.amount = encode_IgnitorDsl(v.amount)
    return o
}

fun decode_IgnitorDsl_Drive(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Drive = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Drive(
    inner = decode_IgnitorDsl(o.inner),
    amount = decode_IgnitorDsl(o.amount),
)

fun encode_IgnitorDsl_Dust(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Dust): dynamic {
    val o: dynamic = wireObj()
    o.density = encode_IgnitorDsl(v.density)
    o.tail = encode_IgnitorDsl(v.tail)
    o.bipolar = encode_IgnitorDsl(v.bipolar)
    return o
}

fun decode_IgnitorDsl_Dust(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Dust = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Dust(
    density = decode_IgnitorDsl(o.density),
    tail = decode_IgnitorDsl(o.tail),
    bipolar = decode_IgnitorDsl(o.bipolar),
)

fun encode_IgnitorDsl_Eq(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Eq): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.sections = wireEncodeList(v.sections) { w9 -> encode_IgnitorDsl_EqSection(w9) }
    return o
}

fun decode_IgnitorDsl_Eq(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Eq = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Eq(
    inner = decode_IgnitorDsl(o.inner),
    sections = wireDecodeList(o.sections) { w10 -> decode_IgnitorDsl_EqSection(w10) },
)

fun encode_IgnitorDsl_Exp(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Exp): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Exp(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Exp = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Exp(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_Floor(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Floor): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Floor(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Floor = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Floor(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_Fm(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Fm): dynamic {
    val o: dynamic = wireObj()
    o.carrier = encode_IgnitorDsl(v.carrier)
    o.modulator = encode_IgnitorDsl(v.modulator)
    o.ratio = encode_IgnitorDsl(v.ratio)
    o.depth = encode_IgnitorDsl(v.depth)
    o.attack = encode_IgnitorDsl(v.attack)
    o.decay = encode_IgnitorDsl(v.decay)
    o.sustain = encode_IgnitorDsl(v.sustain)
    o.release = encode_IgnitorDsl(v.release)
    o.freq = encode_IgnitorDsl(v.freq)
    return o
}

fun decode_IgnitorDsl_Fm(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Fm = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Fm(
    carrier = decode_IgnitorDsl(o.carrier),
    modulator = decode_IgnitorDsl(o.modulator),
    ratio = decode_IgnitorDsl(o.ratio),
    depth = decode_IgnitorDsl(o.depth),
    attack = decode_IgnitorDsl(o.attack),
    decay = decode_IgnitorDsl(o.decay),
    sustain = decode_IgnitorDsl(o.sustain),
    release = decode_IgnitorDsl(o.release),
    freq = decode_IgnitorDsl(o.freq),
)

fun encode_IgnitorDsl_Frac(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Frac): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Frac(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Frac = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Frac(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_Highpass(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Highpass): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.freq = encode_IgnitorDsl(v.freq)
    o.q = encode_IgnitorDsl(v.q)
    o.analog = encode_IgnitorDsl(v.analog)
    o.passes = encode_IgnitorDsl(v.passes)
    o.env = encode_IgnitorDsl(v.env)
    o.attack = encode_IgnitorDsl(v.attack)
    o.decay = encode_IgnitorDsl(v.decay)
    o.sustain = encode_IgnitorDsl(v.sustain)
    o.release = encode_IgnitorDsl(v.release)
    o.attackCurve = encode_IgnitorDsl(v.attackCurve)
    o.decayCurve = encode_IgnitorDsl(v.decayCurve)
    o.releaseCurve = encode_IgnitorDsl(v.releaseCurve)
    o.humanize = v.humanize
    return o
}

fun decode_IgnitorDsl_Highpass(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Highpass = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Highpass(
    inner = decode_IgnitorDsl(o.inner),
    freq = decode_IgnitorDsl(o.freq),
    q = decode_IgnitorDsl(o.q),
    analog = decode_IgnitorDsl(o.analog),
    passes = decode_IgnitorDsl(o.passes),
    env = decode_IgnitorDsl(o.env),
    attack = decode_IgnitorDsl(o.attack),
    decay = decode_IgnitorDsl(o.decay),
    sustain = decode_IgnitorDsl(o.sustain),
    release = decode_IgnitorDsl(o.release),
    attackCurve = decode_IgnitorDsl(o.attackCurve),
    decayCurve = decode_IgnitorDsl(o.decayCurve),
    releaseCurve = decode_IgnitorDsl(o.releaseCurve),
    humanize = o.humanize,
)

fun encode_IgnitorDsl_Impulse(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Impulse): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.analog = encode_IgnitorDsl(v.analog)
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_Impulse(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Impulse = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Impulse(
    freq = decode_IgnitorDsl(o.freq),
    analog = decode_IgnitorDsl(o.analog),
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_Lerp(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Lerp): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_IgnitorDsl(v.left)
    o.right = encode_IgnitorDsl(v.right)
    o.t = encode_IgnitorDsl(v.t)
    return o
}

fun decode_IgnitorDsl_Lerp(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Lerp = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Lerp(
    left = decode_IgnitorDsl(o.left),
    right = decode_IgnitorDsl(o.right),
    t = decode_IgnitorDsl(o.t),
)

fun encode_IgnitorDsl_Log(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Log): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Log(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Log = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Log(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_Lowpass(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Lowpass): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.freq = encode_IgnitorDsl(v.freq)
    o.q = encode_IgnitorDsl(v.q)
    o.analog = encode_IgnitorDsl(v.analog)
    o.passes = encode_IgnitorDsl(v.passes)
    o.env = encode_IgnitorDsl(v.env)
    o.attack = encode_IgnitorDsl(v.attack)
    o.decay = encode_IgnitorDsl(v.decay)
    o.sustain = encode_IgnitorDsl(v.sustain)
    o.release = encode_IgnitorDsl(v.release)
    o.attackCurve = encode_IgnitorDsl(v.attackCurve)
    o.decayCurve = encode_IgnitorDsl(v.decayCurve)
    o.releaseCurve = encode_IgnitorDsl(v.releaseCurve)
    o.humanize = v.humanize
    return o
}

fun decode_IgnitorDsl_Lowpass(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Lowpass = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Lowpass(
    inner = decode_IgnitorDsl(o.inner),
    freq = decode_IgnitorDsl(o.freq),
    q = decode_IgnitorDsl(o.q),
    analog = decode_IgnitorDsl(o.analog),
    passes = decode_IgnitorDsl(o.passes),
    env = decode_IgnitorDsl(o.env),
    attack = decode_IgnitorDsl(o.attack),
    decay = decode_IgnitorDsl(o.decay),
    sustain = decode_IgnitorDsl(o.sustain),
    release = decode_IgnitorDsl(o.release),
    attackCurve = decode_IgnitorDsl(o.attackCurve),
    decayCurve = decode_IgnitorDsl(o.decayCurve),
    releaseCurve = decode_IgnitorDsl(o.releaseCurve),
    humanize = o.humanize,
)

fun encode_IgnitorDsl_Max(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Max): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_IgnitorDsl(v.left)
    o.right = encode_IgnitorDsl(v.right)
    return o
}

fun decode_IgnitorDsl_Max(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Max = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Max(
    left = decode_IgnitorDsl(o.left),
    right = decode_IgnitorDsl(o.right),
)

fun encode_IgnitorDsl_Min(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Min): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_IgnitorDsl(v.left)
    o.right = encode_IgnitorDsl(v.right)
    return o
}

fun decode_IgnitorDsl_Min(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Min = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Min(
    left = decode_IgnitorDsl(o.left),
    right = decode_IgnitorDsl(o.right),
)

fun encode_IgnitorDsl_Minus(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Minus): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_IgnitorDsl(v.left)
    o.right = encode_IgnitorDsl(v.right)
    return o
}

fun decode_IgnitorDsl_Minus(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Minus = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Minus(
    left = decode_IgnitorDsl(o.left),
    right = decode_IgnitorDsl(o.right),
)

fun encode_IgnitorDsl_Mod(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Mod): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_IgnitorDsl(v.left)
    o.right = encode_IgnitorDsl(v.right)
    return o
}

fun decode_IgnitorDsl_Mod(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Mod = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Mod(
    left = decode_IgnitorDsl(o.left),
    right = decode_IgnitorDsl(o.right),
)

fun encode_IgnitorDsl_Neg(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Neg): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Neg(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Neg = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Neg(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_Notch(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Notch): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.freq = encode_IgnitorDsl(v.freq)
    o.q = encode_IgnitorDsl(v.q)
    o.analog = encode_IgnitorDsl(v.analog)
    o.env = encode_IgnitorDsl(v.env)
    o.attack = encode_IgnitorDsl(v.attack)
    o.decay = encode_IgnitorDsl(v.decay)
    o.sustain = encode_IgnitorDsl(v.sustain)
    o.release = encode_IgnitorDsl(v.release)
    o.attackCurve = encode_IgnitorDsl(v.attackCurve)
    o.decayCurve = encode_IgnitorDsl(v.decayCurve)
    o.releaseCurve = encode_IgnitorDsl(v.releaseCurve)
    o.humanize = v.humanize
    return o
}

fun decode_IgnitorDsl_Notch(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Notch = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Notch(
    inner = decode_IgnitorDsl(o.inner),
    freq = decode_IgnitorDsl(o.freq),
    q = decode_IgnitorDsl(o.q),
    analog = decode_IgnitorDsl(o.analog),
    env = decode_IgnitorDsl(o.env),
    attack = decode_IgnitorDsl(o.attack),
    decay = decode_IgnitorDsl(o.decay),
    sustain = decode_IgnitorDsl(o.sustain),
    release = decode_IgnitorDsl(o.release),
    attackCurve = decode_IgnitorDsl(o.attackCurve),
    decayCurve = decode_IgnitorDsl(o.decayCurve),
    releaseCurve = decode_IgnitorDsl(o.releaseCurve),
    humanize = o.humanize,
)

fun encode_IgnitorDsl_OnePoleLowpass(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.OnePoleLowpass): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.freq = encode_IgnitorDsl(v.freq)
    return o
}

fun decode_IgnitorDsl_OnePoleLowpass(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.OnePoleLowpass = io.peekandpoke.klang.audio_bridge.IgnitorDsl.OnePoleLowpass(
    inner = decode_IgnitorDsl(o.inner),
    freq = decode_IgnitorDsl(o.freq),
)

fun encode_IgnitorDsl_OptimizerHint(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.OptimizerHint): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.on = v.on
    return o
}

fun decode_IgnitorDsl_OptimizerHint(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.OptimizerHint = io.peekandpoke.klang.audio_bridge.IgnitorDsl.OptimizerHint(
    inner = decode_IgnitorDsl(o.inner),
    on = o.on,
)

fun encode_IgnitorDsl_OversampleAtLeast(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.OversampleAtLeast): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.body = encode_IgnitorDsl(v.body)
    o.factor = encode_IgnitorDsl(v.factor)
    return o
}

fun decode_IgnitorDsl_OversampleAtLeast(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.OversampleAtLeast = io.peekandpoke.klang.audio_bridge.IgnitorDsl.OversampleAtLeast(
    inner = decode_IgnitorDsl(o.inner),
    body = decode_IgnitorDsl(o.body),
    factor = decode_IgnitorDsl(o.factor),
)

fun encode_IgnitorDsl_OversampleBy(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.OversampleBy): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.body = encode_IgnitorDsl(v.body)
    o.factor = encode_IgnitorDsl(v.factor)
    return o
}

fun decode_IgnitorDsl_OversampleBy(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.OversampleBy = io.peekandpoke.klang.audio_bridge.IgnitorDsl.OversampleBy(
    inner = decode_IgnitorDsl(o.inner),
    body = decode_IgnitorDsl(o.body),
    factor = decode_IgnitorDsl(o.factor),
)

fun encode_IgnitorDsl_Parallel(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Parallel): dynamic {
    val o: dynamic = wireObj()
    o.branches = wireEncodeList(v.branches) { w11 -> encode_IgnitorDsl(w11) }
    return o
}

fun decode_IgnitorDsl_Parallel(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Parallel = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Parallel(
    branches = wireDecodeList(o.branches) { w12 -> decode_IgnitorDsl(w12) },
)

fun encode_IgnitorDsl_Param(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Param): dynamic {
    val o: dynamic = wireObj()
    o.name = v.name
    o.default = v.default
    o.description = v.description
    return o
}

fun decode_IgnitorDsl_Param(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Param = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Param(
    name = o.name,
    default = o.default,
    description = o.description,
)

fun encode_IgnitorDsl_PerlinNoise(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.PerlinNoise): dynamic {
    val o: dynamic = wireObj()
    o.rate = encode_IgnitorDsl(v.rate)
    o.octaves = encode_IgnitorDsl(v.octaves)
    o.persistence = encode_IgnitorDsl(v.persistence)
    return o
}

fun decode_IgnitorDsl_PerlinNoise(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.PerlinNoise = io.peekandpoke.klang.audio_bridge.IgnitorDsl.PerlinNoise(
    rate = decode_IgnitorDsl(o.rate),
    octaves = decode_IgnitorDsl(o.octaves),
    persistence = decode_IgnitorDsl(o.persistence),
)

fun encode_IgnitorDsl_Phaser(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Phaser): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.rate = encode_IgnitorDsl(v.rate)
    o.wet = encode_IgnitorDsl(v.wet)
    o.center = encode_IgnitorDsl(v.center)
    o.sweep = encode_IgnitorDsl(v.sweep)
    o.floor = encode_IgnitorDsl(v.floor)
    return o
}

fun decode_IgnitorDsl_Phaser(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Phaser = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Phaser(
    inner = decode_IgnitorDsl(o.inner),
    rate = decode_IgnitorDsl(o.rate),
    wet = decode_IgnitorDsl(o.wet),
    center = decode_IgnitorDsl(o.center),
    sweep = decode_IgnitorDsl(o.sweep),
    floor = decode_IgnitorDsl(o.floor),
)

fun encode_IgnitorDsl_PinkNoise(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.PinkNoise): dynamic {
    val o: dynamic = wireObj()
    o.uid = v.uid
    return o
}

fun decode_IgnitorDsl_PinkNoise(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.PinkNoise = io.peekandpoke.klang.audio_bridge.IgnitorDsl.PinkNoise(
    uid = o.uid,
)

fun encode_IgnitorDsl_PitchEnvelope(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.PitchEnvelope): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.semitones = encode_IgnitorDsl(v.semitones)
    o.attack = encode_IgnitorDsl(v.attack)
    o.decay = encode_IgnitorDsl(v.decay)
    o.sustain = encode_IgnitorDsl(v.sustain)
    o.release = encode_IgnitorDsl(v.release)
    o.attackCurve = encode_IgnitorDsl(v.attackCurve)
    o.decayCurve = encode_IgnitorDsl(v.decayCurve)
    o.releaseCurve = encode_IgnitorDsl(v.releaseCurve)
    return o
}

fun decode_IgnitorDsl_PitchEnvelope(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.PitchEnvelope = io.peekandpoke.klang.audio_bridge.IgnitorDsl.PitchEnvelope(
    inner = decode_IgnitorDsl(o.inner),
    semitones = decode_IgnitorDsl(o.semitones),
    attack = decode_IgnitorDsl(o.attack),
    decay = decode_IgnitorDsl(o.decay),
    sustain = decode_IgnitorDsl(o.sustain),
    release = decode_IgnitorDsl(o.release),
    attackCurve = decode_IgnitorDsl(o.attackCurve),
    decayCurve = decode_IgnitorDsl(o.decayCurve),
    releaseCurve = decode_IgnitorDsl(o.releaseCurve),
)

fun encode_IgnitorDsl_PitchMod(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.PitchMod): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.mod = encode_IgnitorDsl(v.mod)
    return o
}

fun decode_IgnitorDsl_PitchMod(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.PitchMod = io.peekandpoke.klang.audio_bridge.IgnitorDsl.PitchMod(
    inner = decode_IgnitorDsl(o.inner),
    mod = decode_IgnitorDsl(o.mod),
)

fun encode_IgnitorDsl_PitchModSemitones(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.PitchModSemitones): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.mod = encode_IgnitorDsl(v.mod)
    return o
}

fun decode_IgnitorDsl_PitchModSemitones(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.PitchModSemitones = io.peekandpoke.klang.audio_bridge.IgnitorDsl.PitchModSemitones(
    inner = decode_IgnitorDsl(o.inner),
    mod = decode_IgnitorDsl(o.mod),
)

fun encode_IgnitorDsl_Pluck(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Pluck): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.feedback = encode_IgnitorDsl(v.feedback)
    o.brightness = encode_IgnitorDsl(v.brightness)
    o.pickPosition = encode_IgnitorDsl(v.pickPosition)
    o.stiffness = encode_IgnitorDsl(v.stiffness)
    o.analog = encode_IgnitorDsl(v.analog)
    return o
}

fun decode_IgnitorDsl_Pluck(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Pluck = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Pluck(
    freq = decode_IgnitorDsl(o.freq),
    feedback = decode_IgnitorDsl(o.feedback),
    brightness = decode_IgnitorDsl(o.brightness),
    pickPosition = decode_IgnitorDsl(o.pickPosition),
    stiffness = decode_IgnitorDsl(o.stiffness),
    analog = decode_IgnitorDsl(o.analog),
)

fun encode_IgnitorDsl_Plus(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Plus): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_IgnitorDsl(v.left)
    o.right = encode_IgnitorDsl(v.right)
    return o
}

fun decode_IgnitorDsl_Plus(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Plus = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Plus(
    left = decode_IgnitorDsl(o.left),
    right = decode_IgnitorDsl(o.right),
)

fun encode_IgnitorDsl_Pow(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Pow): dynamic {
    val o: dynamic = wireObj()
    o.base = encode_IgnitorDsl(v.base)
    o.exp = encode_IgnitorDsl(v.exp)
    return o
}

fun decode_IgnitorDsl_Pow(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Pow = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Pow(
    base = decode_IgnitorDsl(o.base),
    exp = decode_IgnitorDsl(o.exp),
)

fun encode_IgnitorDsl_Pulze(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Pulze): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.duty = encode_IgnitorDsl(v.duty)
    o.analog = encode_IgnitorDsl(v.analog)
    o.flankSamples = v.flankSamples
    o.riseFlank = v.riseFlank
    o.fallFlank = v.fallFlank
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_Pulze(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Pulze = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Pulze(
    freq = decode_IgnitorDsl(o.freq),
    duty = decode_IgnitorDsl(o.duty),
    analog = decode_IgnitorDsl(o.analog),
    flankSamples = o.flankSamples,
    riseFlank = o.riseFlank,
    fallFlank = o.fallFlank,
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_Ramp(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Ramp): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.analog = encode_IgnitorDsl(v.analog)
    o.resetSamples = v.resetSamples
    o.shapeMax = v.shapeMax
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_Ramp(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Ramp = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Ramp(
    freq = decode_IgnitorDsl(o.freq),
    analog = decode_IgnitorDsl(o.analog),
    resetSamples = o.resetSamples,
    shapeMax = o.shapeMax,
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_Range(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Range): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.from = encode_IgnitorDsl(v.from)
    o.to = encode_IgnitorDsl(v.to)
    return o
}

fun decode_IgnitorDsl_Range(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Range = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Range(
    inner = decode_IgnitorDsl(o.inner),
    from = decode_IgnitorDsl(o.from),
    to = decode_IgnitorDsl(o.to),
)

fun encode_IgnitorDsl_RawPulze(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.RawPulze): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.duty = encode_IgnitorDsl(v.duty)
    o.analog = encode_IgnitorDsl(v.analog)
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_RawPulze(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.RawPulze = io.peekandpoke.klang.audio_bridge.IgnitorDsl.RawPulze(
    freq = decode_IgnitorDsl(o.freq),
    duty = decode_IgnitorDsl(o.duty),
    analog = decode_IgnitorDsl(o.analog),
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_Recip(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Recip): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Recip(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Recip = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Recip(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_RegionInput(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.RegionInput): dynamic {
    val o: dynamic = wireObj()
    o.up = v.up
    return o
}

fun decode_IgnitorDsl_RegionInput(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.RegionInput = io.peekandpoke.klang.audio_bridge.IgnitorDsl.RegionInput(
    up = o.up,
)

fun encode_IgnitorDsl_Round(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Round): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Round(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Round = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Round(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_Saw(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Saw): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.analog = encode_IgnitorDsl(v.analog)
    o.resetSamples = v.resetSamples
    o.shapeMax = v.shapeMax
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_Saw(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Saw = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Saw(
    freq = decode_IgnitorDsl(o.freq),
    analog = decode_IgnitorDsl(o.analog),
    resetSamples = o.resetSamples,
    shapeMax = o.shapeMax,
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_Select(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Select): dynamic {
    val o: dynamic = wireObj()
    o.cond = encode_IgnitorDsl(v.cond)
    o.whenTrue = encode_IgnitorDsl(v.whenTrue)
    o.whenFalse = encode_IgnitorDsl(v.whenFalse)
    return o
}

fun decode_IgnitorDsl_Select(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Select = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Select(
    cond = decode_IgnitorDsl(o.cond),
    whenTrue = decode_IgnitorDsl(o.whenTrue),
    whenFalse = decode_IgnitorDsl(o.whenFalse),
)

fun encode_IgnitorDsl_Shape(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Shape): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.shape = encode_IgnitorDsl(v.shape)
    return o
}

fun decode_IgnitorDsl_Shape(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Shape = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Shape(
    inner = decode_IgnitorDsl(o.inner),
    shape = decode_IgnitorDsl(o.shape),
)

fun encode_IgnitorDsl_Shimmer(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Shimmer): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.wet = encode_IgnitorDsl(v.wet)
    o.feedback = encode_IgnitorDsl(v.feedback)
    o.pitches = wireEncodeList(v.pitches) { w13 -> w13 }
    o.tone = encode_IgnitorDsl(v.tone)
    o.floor = encode_IgnitorDsl(v.floor)
    return o
}

fun decode_IgnitorDsl_Shimmer(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Shimmer = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Shimmer(
    inner = decode_IgnitorDsl(o.inner),
    wet = decode_IgnitorDsl(o.wet),
    feedback = decode_IgnitorDsl(o.feedback),
    pitches = wireDecodeList(o.pitches) { w14 -> w14 },
    tone = decode_IgnitorDsl(o.tone),
    floor = decode_IgnitorDsl(o.floor),
)

fun encode_IgnitorDsl_Sign(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sign): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Sign(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sign = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sign(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_Sine(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sine): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.analog = encode_IgnitorDsl(v.analog)
    o.fundamental = encode_IgnitorDsl(v.fundamental)
    o.harmonics = encode_IgnitorDsl(v.harmonics)
    o.harmonicsRolloff = encode_IgnitorDsl(v.harmonicsRolloff)
    o.octaves = encode_IgnitorDsl(v.octaves)
    o.octavesRolloff = encode_IgnitorDsl(v.octavesRolloff)
    o.suboctaves = encode_IgnitorDsl(v.suboctaves)
    o.suboctavesRolloff = encode_IgnitorDsl(v.suboctavesRolloff)
    o.analogSpread = encode_IgnitorDsl(v.analogSpread)
    o.phase = encode_IgnitorDsl(v.phase)
    o.partials = wireEncodeList(v.partials) { w15 -> encode_IgnitorDsl_Sine_Partial(w15) }
    return o
}

fun decode_IgnitorDsl_Sine(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sine = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sine(
    freq = decode_IgnitorDsl(o.freq),
    analog = decode_IgnitorDsl(o.analog),
    fundamental = decode_IgnitorDsl(o.fundamental),
    harmonics = decode_IgnitorDsl(o.harmonics),
    harmonicsRolloff = decode_IgnitorDsl(o.harmonicsRolloff),
    octaves = decode_IgnitorDsl(o.octaves),
    octavesRolloff = decode_IgnitorDsl(o.octavesRolloff),
    suboctaves = decode_IgnitorDsl(o.suboctaves),
    suboctavesRolloff = decode_IgnitorDsl(o.suboctavesRolloff),
    analogSpread = decode_IgnitorDsl(o.analogSpread),
    phase = decode_IgnitorDsl(o.phase),
    partials = wireDecodeList(o.partials) { w16 -> decode_IgnitorDsl_Sine_Partial(w16) },
)

fun encode_IgnitorDsl_Sine_Partial(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sine.Partial): dynamic {
    val o: dynamic = wireObj()
    o.ratio = encode_IgnitorDsl(v.ratio)
    o.gain = encode_IgnitorDsl(v.gain)
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_Sine_Partial(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sine.Partial = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sine.Partial(
    ratio = decode_IgnitorDsl(o.ratio),
    gain = decode_IgnitorDsl(o.gain),
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_Sq(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sq): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Sq(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sq = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sq(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_Sqrt(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sqrt): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Sqrt(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sqrt = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Sqrt(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_Square(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Square): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.analog = encode_IgnitorDsl(v.analog)
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_Square(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Square = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Square(
    freq = decode_IgnitorDsl(o.freq),
    analog = decode_IgnitorDsl(o.analog),
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_SuperPluck(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperPluck): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.voices = encode_IgnitorDsl(v.voices)
    o.spread = encode_IgnitorDsl(v.spread)
    o.feedback = encode_IgnitorDsl(v.feedback)
    o.brightness = encode_IgnitorDsl(v.brightness)
    o.pickPosition = encode_IgnitorDsl(v.pickPosition)
    o.stiffness = encode_IgnitorDsl(v.stiffness)
    o.analog = encode_IgnitorDsl(v.analog)
    o.analogSpread = encode_IgnitorDsl(v.analogSpread)
    return o
}

fun decode_IgnitorDsl_SuperPluck(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperPluck = io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperPluck(
    freq = decode_IgnitorDsl(o.freq),
    voices = decode_IgnitorDsl(o.voices),
    spread = decode_IgnitorDsl(o.spread),
    feedback = decode_IgnitorDsl(o.feedback),
    brightness = decode_IgnitorDsl(o.brightness),
    pickPosition = decode_IgnitorDsl(o.pickPosition),
    stiffness = decode_IgnitorDsl(o.stiffness),
    analog = decode_IgnitorDsl(o.analog),
    analogSpread = decode_IgnitorDsl(o.analogSpread),
)

fun encode_IgnitorDsl_SuperRamp(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperRamp): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.voices = encode_IgnitorDsl(v.voices)
    o.spread = encode_IgnitorDsl(v.spread)
    o.analog = encode_IgnitorDsl(v.analog)
    o.analogSpread = encode_IgnitorDsl(v.analogSpread)
    o.spreadPower = v.spreadPower
    o.sideAtten = v.sideAtten
    o.gainJitter = v.gainJitter
    o.centerJitterScale = v.centerJitterScale
    o.phasePool = v.phasePool
    o.drawTries = v.drawTries
    o.kMin = v.kMin
    o.kMax = v.kMax
    o.poolSize = v.poolSize
    o.refreshEvery = v.refreshEvery
    o.selection = v.selection
    o.warmup = v.warmup
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_SuperRamp(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperRamp = io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperRamp(
    freq = decode_IgnitorDsl(o.freq),
    voices = decode_IgnitorDsl(o.voices),
    spread = decode_IgnitorDsl(o.spread),
    analog = decode_IgnitorDsl(o.analog),
    analogSpread = decode_IgnitorDsl(o.analogSpread),
    spreadPower = o.spreadPower,
    sideAtten = o.sideAtten,
    gainJitter = o.gainJitter,
    centerJitterScale = o.centerJitterScale,
    phasePool = o.phasePool,
    drawTries = o.drawTries,
    kMin = o.kMin,
    kMax = o.kMax,
    poolSize = o.poolSize,
    refreshEvery = o.refreshEvery,
    selection = o.selection,
    warmup = o.warmup,
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_SuperSaw(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperSaw): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.voices = encode_IgnitorDsl(v.voices)
    o.spread = encode_IgnitorDsl(v.spread)
    o.analog = encode_IgnitorDsl(v.analog)
    o.analogSpread = encode_IgnitorDsl(v.analogSpread)
    o.spreadPower = v.spreadPower
    o.sideAtten = v.sideAtten
    o.gainJitter = v.gainJitter
    o.centerJitterScale = v.centerJitterScale
    o.phasePool = v.phasePool
    o.drawTries = v.drawTries
    o.kMin = v.kMin
    o.kMax = v.kMax
    o.poolSize = v.poolSize
    o.refreshEvery = v.refreshEvery
    o.selection = v.selection
    o.warmup = v.warmup
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_SuperSaw(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperSaw = io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperSaw(
    freq = decode_IgnitorDsl(o.freq),
    voices = decode_IgnitorDsl(o.voices),
    spread = decode_IgnitorDsl(o.spread),
    analog = decode_IgnitorDsl(o.analog),
    analogSpread = decode_IgnitorDsl(o.analogSpread),
    spreadPower = o.spreadPower,
    sideAtten = o.sideAtten,
    gainJitter = o.gainJitter,
    centerJitterScale = o.centerJitterScale,
    phasePool = o.phasePool,
    drawTries = o.drawTries,
    kMin = o.kMin,
    kMax = o.kMax,
    poolSize = o.poolSize,
    refreshEvery = o.refreshEvery,
    selection = o.selection,
    warmup = o.warmup,
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_SuperSine(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperSine): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.voices = encode_IgnitorDsl(v.voices)
    o.spread = encode_IgnitorDsl(v.spread)
    o.analog = encode_IgnitorDsl(v.analog)
    o.analogSpread = encode_IgnitorDsl(v.analogSpread)
    o.spreadPower = v.spreadPower
    o.sideAtten = v.sideAtten
    o.gainJitter = v.gainJitter
    o.centerJitterScale = v.centerJitterScale
    o.phasePool = v.phasePool
    o.drawTries = v.drawTries
    o.kMin = v.kMin
    o.kMax = v.kMax
    o.poolSize = v.poolSize
    o.refreshEvery = v.refreshEvery
    o.selection = v.selection
    o.warmup = v.warmup
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_SuperSine(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperSine = io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperSine(
    freq = decode_IgnitorDsl(o.freq),
    voices = decode_IgnitorDsl(o.voices),
    spread = decode_IgnitorDsl(o.spread),
    analog = decode_IgnitorDsl(o.analog),
    analogSpread = decode_IgnitorDsl(o.analogSpread),
    spreadPower = o.spreadPower,
    sideAtten = o.sideAtten,
    gainJitter = o.gainJitter,
    centerJitterScale = o.centerJitterScale,
    phasePool = o.phasePool,
    drawTries = o.drawTries,
    kMin = o.kMin,
    kMax = o.kMax,
    poolSize = o.poolSize,
    refreshEvery = o.refreshEvery,
    selection = o.selection,
    warmup = o.warmup,
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_SuperSquare(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperSquare): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.voices = encode_IgnitorDsl(v.voices)
    o.spread = encode_IgnitorDsl(v.spread)
    o.analog = encode_IgnitorDsl(v.analog)
    o.analogSpread = encode_IgnitorDsl(v.analogSpread)
    o.spreadPower = v.spreadPower
    o.sideAtten = v.sideAtten
    o.gainJitter = v.gainJitter
    o.centerJitterScale = v.centerJitterScale
    o.phasePool = v.phasePool
    o.drawTries = v.drawTries
    o.kMin = v.kMin
    o.kMax = v.kMax
    o.poolSize = v.poolSize
    o.refreshEvery = v.refreshEvery
    o.selection = v.selection
    o.warmup = v.warmup
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_SuperSquare(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperSquare = io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperSquare(
    freq = decode_IgnitorDsl(o.freq),
    voices = decode_IgnitorDsl(o.voices),
    spread = decode_IgnitorDsl(o.spread),
    analog = decode_IgnitorDsl(o.analog),
    analogSpread = decode_IgnitorDsl(o.analogSpread),
    spreadPower = o.spreadPower,
    sideAtten = o.sideAtten,
    gainJitter = o.gainJitter,
    centerJitterScale = o.centerJitterScale,
    phasePool = o.phasePool,
    drawTries = o.drawTries,
    kMin = o.kMin,
    kMax = o.kMax,
    poolSize = o.poolSize,
    refreshEvery = o.refreshEvery,
    selection = o.selection,
    warmup = o.warmup,
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_SuperTri(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperTri): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.voices = encode_IgnitorDsl(v.voices)
    o.spread = encode_IgnitorDsl(v.spread)
    o.analog = encode_IgnitorDsl(v.analog)
    o.analogSpread = encode_IgnitorDsl(v.analogSpread)
    o.spreadPower = v.spreadPower
    o.sideAtten = v.sideAtten
    o.gainJitter = v.gainJitter
    o.centerJitterScale = v.centerJitterScale
    o.phasePool = v.phasePool
    o.drawTries = v.drawTries
    o.kMin = v.kMin
    o.kMax = v.kMax
    o.poolSize = v.poolSize
    o.refreshEvery = v.refreshEvery
    o.selection = v.selection
    o.warmup = v.warmup
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_SuperTri(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperTri = io.peekandpoke.klang.audio_bridge.IgnitorDsl.SuperTri(
    freq = decode_IgnitorDsl(o.freq),
    voices = decode_IgnitorDsl(o.voices),
    spread = decode_IgnitorDsl(o.spread),
    analog = decode_IgnitorDsl(o.analog),
    analogSpread = decode_IgnitorDsl(o.analogSpread),
    spreadPower = o.spreadPower,
    sideAtten = o.sideAtten,
    gainJitter = o.gainJitter,
    centerJitterScale = o.centerJitterScale,
    phasePool = o.phasePool,
    drawTries = o.drawTries,
    kMin = o.kMin,
    kMax = o.kMax,
    poolSize = o.poolSize,
    refreshEvery = o.refreshEvery,
    selection = o.selection,
    warmup = o.warmup,
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_Tanh(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Tanh): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    return o
}

fun decode_IgnitorDsl_Tanh(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Tanh = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Tanh(
    inner = decode_IgnitorDsl(o.inner),
)

fun encode_IgnitorDsl_Times(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Times): dynamic {
    val o: dynamic = wireObj()
    o.left = encode_IgnitorDsl(v.left)
    o.right = encode_IgnitorDsl(v.right)
    return o
}

fun decode_IgnitorDsl_Times(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Times = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Times(
    left = decode_IgnitorDsl(o.left),
    right = decode_IgnitorDsl(o.right),
)

fun encode_IgnitorDsl_Tremolo(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Tremolo): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.rate = encode_IgnitorDsl(v.rate)
    o.depth = encode_IgnitorDsl(v.depth)
    o.shape = encode_IgnitorDsl(v.shape)
    o.rangeFrom = encode_IgnitorDsl(v.rangeFrom)
    o.rangeTo = encode_IgnitorDsl(v.rangeTo)
    return o
}

fun decode_IgnitorDsl_Tremolo(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Tremolo = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Tremolo(
    inner = decode_IgnitorDsl(o.inner),
    rate = decode_IgnitorDsl(o.rate),
    depth = decode_IgnitorDsl(o.depth),
    shape = decode_IgnitorDsl(o.shape),
    rangeFrom = decode_IgnitorDsl(o.rangeFrom),
    rangeTo = decode_IgnitorDsl(o.rangeTo),
)

fun encode_IgnitorDsl_Tri(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Tri): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.analog = encode_IgnitorDsl(v.analog)
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_Tri(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Tri = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Tri(
    freq = decode_IgnitorDsl(o.freq),
    analog = decode_IgnitorDsl(o.analog),
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_Variants(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Variants): dynamic {
    val o: dynamic = wireObj()
    o.children = wireEncodeList(v.children) { w17 -> encode_IgnitorDsl(w17) }
    return o
}

fun decode_IgnitorDsl_Variants(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Variants = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Variants(
    children = wireDecodeList(o.children) { w18 -> decode_IgnitorDsl(w18) },
)

fun encode_IgnitorDsl_Vibrato(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Vibrato): dynamic {
    val o: dynamic = wireObj()
    o.inner = encode_IgnitorDsl(v.inner)
    o.rate = encode_IgnitorDsl(v.rate)
    o.semitones = encode_IgnitorDsl(v.semitones)
    o.rangeFrom = encode_IgnitorDsl(v.rangeFrom)
    o.rangeTo = encode_IgnitorDsl(v.rangeTo)
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_Vibrato(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Vibrato = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Vibrato(
    inner = decode_IgnitorDsl(o.inner),
    rate = decode_IgnitorDsl(o.rate),
    semitones = decode_IgnitorDsl(o.semitones),
    rangeFrom = decode_IgnitorDsl(o.rangeFrom),
    rangeTo = decode_IgnitorDsl(o.rangeTo),
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_WhiteNoise(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.WhiteNoise): dynamic {
    val o: dynamic = wireObj()
    o.color = encode_IgnitorDsl(v.color)
    o.uid = v.uid
    return o
}

fun decode_IgnitorDsl_WhiteNoise(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.WhiteNoise = io.peekandpoke.klang.audio_bridge.IgnitorDsl.WhiteNoise(
    color = decode_IgnitorDsl(o.color),
    uid = o.uid,
)

fun encode_IgnitorDsl_Zamp(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Zamp): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.analog = encode_IgnitorDsl(v.analog)
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_Zamp(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Zamp = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Zamp(
    freq = decode_IgnitorDsl(o.freq),
    analog = decode_IgnitorDsl(o.analog),
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_Zawtooth(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.Zawtooth): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.analog = encode_IgnitorDsl(v.analog)
    o.phase = encode_IgnitorDsl(v.phase)
    return o
}

fun decode_IgnitorDsl_Zawtooth(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.Zawtooth = io.peekandpoke.klang.audio_bridge.IgnitorDsl.Zawtooth(
    freq = decode_IgnitorDsl(o.freq),
    analog = decode_IgnitorDsl(o.analog),
    phase = decode_IgnitorDsl(o.phase),
)

fun encode_IgnitorDsl_EqSection_Bell(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Bell): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.q = encode_IgnitorDsl(v.q)
    o.db = encode_IgnitorDsl(v.db)
    return o
}

fun decode_IgnitorDsl_EqSection_Bell(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Bell = io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Bell(
    freq = decode_IgnitorDsl(o.freq),
    q = decode_IgnitorDsl(o.q),
    db = decode_IgnitorDsl(o.db),
)

fun encode_IgnitorDsl_EqSection_Highpass(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Highpass): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.q = encode_IgnitorDsl(v.q)
    return o
}

fun decode_IgnitorDsl_EqSection_Highpass(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Highpass = io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Highpass(
    freq = decode_IgnitorDsl(o.freq),
    q = decode_IgnitorDsl(o.q),
)

fun encode_IgnitorDsl_EqSection_Lowpass(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Lowpass): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.q = encode_IgnitorDsl(v.q)
    return o
}

fun decode_IgnitorDsl_EqSection_Lowpass(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Lowpass = io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Lowpass(
    freq = decode_IgnitorDsl(o.freq),
    q = decode_IgnitorDsl(o.q),
)

fun encode_IgnitorDsl_EqSection_Notch(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Notch): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.q = encode_IgnitorDsl(v.q)
    return o
}

fun decode_IgnitorDsl_EqSection_Notch(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Notch = io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.Notch(
    freq = decode_IgnitorDsl(o.freq),
    q = decode_IgnitorDsl(o.q),
)

fun encode_IgnitorDsl_EqSection_RawTap(v: io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.RawTap): dynamic {
    val o: dynamic = wireObj()
    o.freq = encode_IgnitorDsl(v.freq)
    o.q = encode_IgnitorDsl(v.q)
    o.gain = encode_IgnitorDsl(v.gain)
    return o
}

fun decode_IgnitorDsl_EqSection_RawTap(o: dynamic): io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.RawTap = io.peekandpoke.klang.audio_bridge.IgnitorDsl.EqSection.RawTap(
    freq = decode_IgnitorDsl(o.freq),
    q = decode_IgnitorDsl(o.q),
    gain = decode_IgnitorDsl(o.gain),
)

fun encode_KatalystStageDsl_Gain(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Gain): dynamic {
    val o: dynamic = wireObj()
    o.gain = encode_KatalystKnobDsl(v.gain)
    return o
}

fun decode_KatalystStageDsl_Gain(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Gain = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Gain(
    gain = decode_KatalystKnobDsl(o.gain),
)

fun encode_KatalystStageDsl_Max(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Max): dynamic {
    val o: dynamic = wireObj()
    o.other = encode_KatalystKnobDsl(v.other)
    return o
}

fun decode_KatalystStageDsl_Max(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Max = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Max(
    other = decode_KatalystKnobDsl(o.other),
)

fun encode_KatalystStageDsl_Min(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Min): dynamic {
    val o: dynamic = wireObj()
    o.other = encode_KatalystKnobDsl(v.other)
    return o
}

fun decode_KatalystStageDsl_Min(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Min = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Min(
    other = decode_KatalystKnobDsl(o.other),
)

fun encode_KatalystStageDsl_Minus(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Minus): dynamic {
    val o: dynamic = wireObj()
    o.other = encode_KatalystKnobDsl(v.other)
    return o
}

fun decode_KatalystStageDsl_Minus(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Minus = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Minus(
    other = decode_KatalystKnobDsl(o.other),
)

fun encode_KatalystStageDsl_OversampleAtLeast(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.OversampleAtLeast): dynamic {
    val o: dynamic = wireObj()
    o.factor = v.factor
    o.body = encode_KatalystDsl(v.body)
    return o
}

fun decode_KatalystStageDsl_OversampleAtLeast(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.OversampleAtLeast = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.OversampleAtLeast(
    factor = o.factor,
    body = decode_KatalystDsl(o.body),
)

fun encode_KatalystStageDsl_OversampleBy(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.OversampleBy): dynamic {
    val o: dynamic = wireObj()
    o.factor = v.factor
    o.body = encode_KatalystDsl(v.body)
    return o
}

fun decode_KatalystStageDsl_OversampleBy(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.OversampleBy = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.OversampleBy(
    factor = o.factor,
    body = decode_KatalystDsl(o.body),
)

fun encode_KatalystStageDsl_Parallel(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Parallel): dynamic {
    val o: dynamic = wireObj()
    o.branches = wireEncodeList(v.branches) { w19 -> encode_KatalystDsl(w19) }
    return o
}

fun decode_KatalystStageDsl_Parallel(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Parallel = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Parallel(
    branches = wireDecodeList(o.branches) { w20 -> decode_KatalystDsl(w20) },
)

fun encode_KatalystStageDsl_Phaser(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Phaser): dynamic {
    val o: dynamic = wireObj()
    o.rate = encode_KatalystKnobDsl(v.rate)
    o.wet = encode_KatalystKnobDsl(v.wet)
    o.center = encode_KatalystKnobDsl(v.center)
    o.sweep = encode_KatalystKnobDsl(v.sweep)
    o.floor = encode_KatalystKnobDsl(v.floor)
    return o
}

fun decode_KatalystStageDsl_Phaser(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Phaser = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Phaser(
    rate = decode_KatalystKnobDsl(o.rate),
    wet = decode_KatalystKnobDsl(o.wet),
    center = decode_KatalystKnobDsl(o.center),
    sweep = decode_KatalystKnobDsl(o.sweep),
    floor = decode_KatalystKnobDsl(o.floor),
)

fun encode_KatalystStageDsl_Plus(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Plus): dynamic {
    val o: dynamic = wireObj()
    o.other = encode_KatalystKnobDsl(v.other)
    return o
}

fun decode_KatalystStageDsl_Plus(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Plus = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Plus(
    other = decode_KatalystKnobDsl(o.other),
)

fun encode_KatalystStageDsl_Pow(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Pow): dynamic {
    val o: dynamic = wireObj()
    o.exp = encode_KatalystKnobDsl(v.exp)
    return o
}

fun decode_KatalystStageDsl_Pow(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Pow = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Pow(
    exp = decode_KatalystKnobDsl(o.exp),
)

fun encode_KatalystStageDsl_Reverb(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Reverb): dynamic {
    val o: dynamic = wireObj()
    o.wet = encode_KatalystKnobDsl(v.wet)
    o.size = encode_KatalystKnobDsl(v.size)
    o.lowpass = v.lowpass?.let { w21 -> encode_KatalystKnobDsl(w21) }
    return o
}

fun decode_KatalystStageDsl_Reverb(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Reverb = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Reverb(
    wet = decode_KatalystKnobDsl(o.wet),
    size = decode_KatalystKnobDsl(o.size),
    lowpass = if (o.lowpass != null) decode_KatalystKnobDsl(o.lowpass) else null,
)

fun encode_KatalystStageDsl_Times(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Times): dynamic {
    val o: dynamic = wireObj()
    o.other = encode_KatalystKnobDsl(v.other)
    return o
}

fun decode_KatalystStageDsl_Times(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Times = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Times(
    other = decode_KatalystKnobDsl(o.other),
)

fun encode_KatalystStageDsl_Vowel(v: io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Vowel): dynamic {
    val o: dynamic = wireObj()
    o.vowel = encode_KatalystKnobDsl(v.vowel)
    o.wet = encode_KatalystKnobDsl(v.wet)
    o.floor = encode_KatalystKnobDsl(v.floor)
    return o
}

fun decode_KatalystStageDsl_Vowel(o: dynamic): io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Vowel = io.peekandpoke.klang.audio_bridge.KatalystStageDsl.Vowel(
    vowel = decode_KatalystKnobDsl(o.vowel),
    wet = decode_KatalystKnobDsl(o.wet),
    floor = decode_KatalystKnobDsl(o.floor),
)

fun encode_KlangCommLink_Cmd(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd): dynamic = wireScoped { when (v) {
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Cleanup -> { val o = encode_KlangCommLink_Cmd_Cleanup(v); o["#t"] = "cleanup"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ClearScheduled -> { val o = encode_KlangCommLink_Cmd_ClearScheduled(v); o["#t"] = "clear-scheduled"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.RegisterIgnitor -> { val o = encode_KlangCommLink_Cmd_RegisterIgnitor(v); o["#t"] = "register-ignitor"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.RegisterKatalyst -> { val o = encode_KlangCommLink_Cmd_RegisterKatalyst(v); o["#t"] = "register-katalyst"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ReplaceVoices -> { val o = encode_KlangCommLink_Cmd_ReplaceVoices(v); o["#t"] = "replace-voices"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.Chunk -> { val o = encode_KlangCommLink_Cmd_Sample_Chunk(v); o["#t"] = "sample-chunk"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.Complete -> { val o = encode_KlangCommLink_Cmd_Sample_Complete(v); o["#t"] = "sample-complete"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.NotFound -> { val o = encode_KlangCommLink_Cmd_Sample_NotFound(v); o["#t"] = "sample-not-found"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ScheduleVoice -> { val o = encode_KlangCommLink_Cmd_ScheduleVoice(v); o["#t"] = "schedule-voice"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ScheduleVoices -> { val o = encode_KlangCommLink_Cmd_ScheduleVoices(v); o["#t"] = "schedule-voices"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.SetGain -> { val o = encode_KlangCommLink_Cmd_SetGain(v); o["#t"] = "set-gain"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.StartRealtimeVoice -> { val o = encode_KlangCommLink_Cmd_StartRealtimeVoice(v); o["#t"] = "start-realtime-voice"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.StopRealtimeVoice -> { val o = encode_KlangCommLink_Cmd_StopRealtimeVoice(v); o["#t"] = "stop-realtime-voice"; o }
}}

fun decode_KlangCommLink_Cmd(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd = wireScoped { when (o["#t"].unsafeCast<String>()) {
    "cleanup" -> decode_KlangCommLink_Cmd_Cleanup(o)
    "clear-scheduled" -> decode_KlangCommLink_Cmd_ClearScheduled(o)
    "register-ignitor" -> decode_KlangCommLink_Cmd_RegisterIgnitor(o)
    "register-katalyst" -> decode_KlangCommLink_Cmd_RegisterKatalyst(o)
    "replace-voices" -> decode_KlangCommLink_Cmd_ReplaceVoices(o)
    "sample-chunk" -> decode_KlangCommLink_Cmd_Sample_Chunk(o)
    "sample-complete" -> decode_KlangCommLink_Cmd_Sample_Complete(o)
    "sample-not-found" -> decode_KlangCommLink_Cmd_Sample_NotFound(o)
    "schedule-voice" -> decode_KlangCommLink_Cmd_ScheduleVoice(o)
    "schedule-voices" -> decode_KlangCommLink_Cmd_ScheduleVoices(o)
    "set-gain" -> decode_KlangCommLink_Cmd_SetGain(o)
    "start-realtime-voice" -> decode_KlangCommLink_Cmd_StartRealtimeVoice(o)
    "stop-realtime-voice" -> decode_KlangCommLink_Cmd_StopRealtimeVoice(o)
    else -> throw IllegalStateException("wire-codec: unknown KlangCommLink_Cmd tag " + o["#t"])
}}

fun encode_KlangCommLink_Cmd_Cleanup(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Cleanup): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    return o
}

fun decode_KlangCommLink_Cmd_Cleanup(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Cleanup = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Cleanup(
    playbackId = o.playbackId,
)

fun encode_KlangCommLink_Cmd_ClearScheduled(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ClearScheduled): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    return o
}

fun decode_KlangCommLink_Cmd_ClearScheduled(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ClearScheduled = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ClearScheduled(
    playbackId = o.playbackId,
)

fun encode_KlangCommLink_Cmd_RegisterIgnitor(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.RegisterIgnitor): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.name = v.name
    o.dsl = encode_IgnitorDsl(v.dsl)
    return o
}

fun decode_KlangCommLink_Cmd_RegisterIgnitor(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.RegisterIgnitor = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.RegisterIgnitor(
    playbackId = o.playbackId,
    name = o.name,
    dsl = decode_IgnitorDsl(o.dsl),
)

fun encode_KlangCommLink_Cmd_RegisterKatalyst(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.RegisterKatalyst): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.name = v.name
    o.dsl = encode_KatalystDsl(v.dsl)
    return o
}

fun decode_KlangCommLink_Cmd_RegisterKatalyst(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.RegisterKatalyst = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.RegisterKatalyst(
    playbackId = o.playbackId,
    name = o.name,
    dsl = decode_KatalystDsl(o.dsl),
)

fun encode_KlangCommLink_Cmd_ReplaceVoices(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ReplaceVoices): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.voices = wireEncodeList(v.voices) { w22 -> encode_ScheduledVoice(w22) }
    o.afterTimeSec = v.afterTimeSec
    return o
}

fun decode_KlangCommLink_Cmd_ReplaceVoices(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ReplaceVoices = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ReplaceVoices(
    playbackId = o.playbackId,
    voices = wireDecodeList(o.voices) { w23 -> decode_ScheduledVoice(w23) },
    afterTimeSec = o.afterTimeSec,
)

fun encode_KlangCommLink_Cmd_Sample(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample): dynamic = when (v) {
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.Chunk -> { val o = encode_KlangCommLink_Cmd_Sample_Chunk(v); o["#t"] = "sample-chunk"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.Complete -> { val o = encode_KlangCommLink_Cmd_Sample_Complete(v); o["#t"] = "sample-complete"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.NotFound -> { val o = encode_KlangCommLink_Cmd_Sample_NotFound(v); o["#t"] = "sample-not-found"; o }
}

fun decode_KlangCommLink_Cmd_Sample(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample = when (o["#t"].unsafeCast<String>()) {
    "sample-chunk" -> decode_KlangCommLink_Cmd_Sample_Chunk(o)
    "sample-complete" -> decode_KlangCommLink_Cmd_Sample_Complete(o)
    "sample-not-found" -> decode_KlangCommLink_Cmd_Sample_NotFound(o)
    else -> throw IllegalStateException("wire-codec: unknown KlangCommLink_Cmd_Sample tag " + o["#t"])
}

fun encode_KlangCommLink_Cmd_Sample_Chunk(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.Chunk): dynamic {
    val o: dynamic = wireObj()
    o.req = encode_SampleRequest(v.req)
    o.note = v.note
    o.pitchHz = v.pitchHz
    o.sampleRate = v.sampleRate
    o.meta = encode_SampleMetadata(v.meta)
    o.totalSize = v.totalSize
    o.isLastChunk = v.isLastChunk
    o.chunkOffset = v.chunkOffset
    o.data = v.data
    return o
}

fun decode_KlangCommLink_Cmd_Sample_Chunk(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.Chunk = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.Chunk(
    req = decode_SampleRequest(o.req),
    note = o.note,
    pitchHz = o.pitchHz,
    sampleRate = o.sampleRate,
    meta = decode_SampleMetadata(o.meta),
    totalSize = o.totalSize,
    isLastChunk = o.isLastChunk,
    chunkOffset = o.chunkOffset,
    data = o.data,
)

fun encode_SampleRequest(v: io.peekandpoke.klang.audio_bridge.SampleRequest): dynamic = wireScoped {
    val o: dynamic = wireObj()
    o.bank = v.bank
    o.sound = v.sound
    o.index = v.index
    o.note = v.note
    o
}

fun decode_SampleRequest(o: dynamic): io.peekandpoke.klang.audio_bridge.SampleRequest = wireScoped { io.peekandpoke.klang.audio_bridge.SampleRequest(
    bank = o.bank,
    sound = o.sound,
    index = o.index,
    note = o.note,
)}

fun encode_SampleMetadata(v: io.peekandpoke.klang.audio_bridge.SampleMetadata): dynamic {
    val o: dynamic = wireObj()
    o.anchor = v.anchor
    o.loop = v.loop?.let { w24 -> encode_SampleMetadata_LoopRange(w24) }
    o.adsr = v.adsr?.let { w25 -> encode_AdsrDef(w25) }
    return o
}

fun decode_SampleMetadata(o: dynamic): io.peekandpoke.klang.audio_bridge.SampleMetadata = io.peekandpoke.klang.audio_bridge.SampleMetadata(
    anchor = o.anchor,
    loop = if (o.loop != null) decode_SampleMetadata_LoopRange(o.loop) else null,
    adsr = if (o.adsr != null) decode_AdsrDef(o.adsr) else null,
)

fun encode_SampleMetadata_LoopRange(v: io.peekandpoke.klang.audio_bridge.SampleMetadata.LoopRange): dynamic {
    val o: dynamic = wireObj()
    o.startSec = v.startSec
    o.endSec = v.endSec
    return o
}

fun decode_SampleMetadata_LoopRange(o: dynamic): io.peekandpoke.klang.audio_bridge.SampleMetadata.LoopRange = io.peekandpoke.klang.audio_bridge.SampleMetadata.LoopRange(
    startSec = o.startSec,
    endSec = o.endSec,
)

fun encode_AdsrDef(v: io.peekandpoke.klang.audio_bridge.AdsrDef): dynamic = when (v) {
    is io.peekandpoke.klang.audio_bridge.AdsrDef.Std -> { val o = encode_AdsrDef_Std(v); o["#t"] = "std"; o }
}

fun decode_AdsrDef(o: dynamic): io.peekandpoke.klang.audio_bridge.AdsrDef = when (o["#t"].unsafeCast<String>()) {
    "std" -> decode_AdsrDef_Std(o)
    else -> throw IllegalStateException("wire-codec: unknown AdsrDef tag " + o["#t"])
}

fun encode_AdsrDef_Std(v: io.peekandpoke.klang.audio_bridge.AdsrDef.Std): dynamic {
    val o: dynamic = wireObj()
    o.attack = v.attack
    o.decay = v.decay
    o.sustain = v.sustain
    o.release = v.release
    o.attackCurve = v.attackCurve?.ordinal
    o.decayCurve = v.decayCurve?.ordinal
    o.releaseCurve = v.releaseCurve?.ordinal
    return o
}

fun decode_AdsrDef_Std(o: dynamic): io.peekandpoke.klang.audio_bridge.AdsrDef.Std = io.peekandpoke.klang.audio_bridge.AdsrDef.Std(
    attack = o.attack,
    decay = o.decay,
    sustain = o.sustain,
    release = o.release,
    attackCurve = if (o.attackCurve != null) io.peekandpoke.klang.audio_bridge.AdsrCurve.entries[(o.attackCurve).unsafeCast<Int>()] else null,
    decayCurve = if (o.decayCurve != null) io.peekandpoke.klang.audio_bridge.AdsrCurve.entries[(o.decayCurve).unsafeCast<Int>()] else null,
    releaseCurve = if (o.releaseCurve != null) io.peekandpoke.klang.audio_bridge.AdsrCurve.entries[(o.releaseCurve).unsafeCast<Int>()] else null,
)

fun encode_KlangCommLink_Cmd_Sample_Complete(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.Complete): dynamic {
    val o: dynamic = wireObj()
    o.req = encode_SampleRequest(v.req)
    o.note = v.note
    o.pitchHz = v.pitchHz
    o.sample = encode_MonoSamplePcm(v.sample)
    return o
}

fun decode_KlangCommLink_Cmd_Sample_Complete(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.Complete = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.Complete(
    req = decode_SampleRequest(o.req),
    note = o.note,
    pitchHz = o.pitchHz,
    sample = decode_MonoSamplePcm(o.sample),
)

fun encode_MonoSamplePcm(v: io.peekandpoke.klang.audio_bridge.MonoSamplePcm): dynamic {
    val o: dynamic = wireObj()
    o.sampleRate = v.sampleRate
    o.pcm = v.pcm
    o.meta = encode_SampleMetadata(v.meta)
    return o
}

fun decode_MonoSamplePcm(o: dynamic): io.peekandpoke.klang.audio_bridge.MonoSamplePcm = io.peekandpoke.klang.audio_bridge.MonoSamplePcm(
    sampleRate = o.sampleRate,
    pcm = o.pcm,
    meta = decode_SampleMetadata(o.meta),
)

fun encode_KlangCommLink_Cmd_Sample_NotFound(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.NotFound): dynamic {
    val o: dynamic = wireObj()
    o.req = encode_SampleRequest(v.req)
    return o
}

fun decode_KlangCommLink_Cmd_Sample_NotFound(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.NotFound = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.Sample.NotFound(
    req = decode_SampleRequest(o.req),
)

fun encode_KlangCommLink_Cmd_ScheduleVoice(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ScheduleVoice): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.voice = encode_ScheduledVoice(v.voice)
    return o
}

fun decode_KlangCommLink_Cmd_ScheduleVoice(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ScheduleVoice = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ScheduleVoice(
    playbackId = o.playbackId,
    voice = decode_ScheduledVoice(o.voice),
)

fun encode_KlangCommLink_Cmd_ScheduleVoices(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ScheduleVoices): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.voices = wireEncodeList(v.voices) { w26 -> encode_ScheduledVoice(w26) }
    return o
}

fun decode_KlangCommLink_Cmd_ScheduleVoices(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ScheduleVoices = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.ScheduleVoices(
    playbackId = o.playbackId,
    voices = wireDecodeList(o.voices) { w27 -> decode_ScheduledVoice(w27) },
)

fun encode_KlangCommLink_Cmd_SetGain(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.SetGain): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.gain = v.gain
    o.rampSec = v.rampSec
    return o
}

fun decode_KlangCommLink_Cmd_SetGain(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.SetGain = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.SetGain(
    playbackId = o.playbackId,
    gain = o.gain,
    rampSec = o.rampSec,
)

fun encode_KlangCommLink_Cmd_StartRealtimeVoice(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.StartRealtimeVoice): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.voice = encode_RealtimeVoice(v.voice)
    return o
}

fun decode_KlangCommLink_Cmd_StartRealtimeVoice(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.StartRealtimeVoice = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.StartRealtimeVoice(
    playbackId = o.playbackId,
    voice = decode_RealtimeVoice(o.voice),
)

fun encode_KlangCommLink_Cmd_StopRealtimeVoice(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.StopRealtimeVoice): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.liveId = v.liveId
    return o
}

fun decode_KlangCommLink_Cmd_StopRealtimeVoice(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.StopRealtimeVoice = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Cmd.StopRealtimeVoice(
    playbackId = o.playbackId,
    liveId = o.liveId,
)

fun encode_KlangCommLink_Feedback(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback): dynamic = wireScoped { when (v) {
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.BackendReady -> { val o = encode_KlangCommLink_Feedback_BackendReady(v); o["#t"] = "backend-ready"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.Diagnostics -> { val o = encode_KlangCommLink_Feedback_Diagnostics(v); o["#t"] = "diagnostics"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.PlaybackAnchored -> { val o = encode_KlangCommLink_Feedback_PlaybackAnchored(v); o["#t"] = "playback-anchored"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.RequestSample -> { val o = encode_KlangCommLink_Feedback_RequestSample(v); o["#t"] = "request-sample"; o }
    is io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.SampleReceived -> { val o = encode_KlangCommLink_Feedback_SampleReceived(v); o["#t"] = "sample-received"; o }
}}

fun decode_KlangCommLink_Feedback(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback = wireScoped { when (o["#t"].unsafeCast<String>()) {
    "backend-ready" -> decode_KlangCommLink_Feedback_BackendReady(o)
    "diagnostics" -> decode_KlangCommLink_Feedback_Diagnostics(o)
    "playback-anchored" -> decode_KlangCommLink_Feedback_PlaybackAnchored(o)
    "request-sample" -> decode_KlangCommLink_Feedback_RequestSample(o)
    "sample-received" -> decode_KlangCommLink_Feedback_SampleReceived(o)
    else -> throw IllegalStateException("wire-codec: unknown KlangCommLink_Feedback tag " + o["#t"])
}}

fun encode_KlangCommLink_Feedback_BackendReady(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.BackendReady): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    return o
}

fun decode_KlangCommLink_Feedback_BackendReady(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.BackendReady = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.BackendReady(
    playbackId = o.playbackId,
)

fun encode_KlangCommLink_Feedback_Diagnostics(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.Diagnostics): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.sampleRate = v.sampleRate
    o.renderHeadroom = v.renderHeadroom
    o.activeVoiceCount = v.activeVoiceCount
    o.cylinders = wireEncodeList(v.cylinders) { w28 -> encode_KlangCommLink_Feedback_Diagnostics_CylinderState(w28) }
    o.backendNowMs = v.backendNowMs
    o.baseLatencyMs = v.baseLatencyMs
    o.outputDeviceLatencyMs = v.outputDeviceLatencyMs
    o.outputLatencyMs = v.outputLatencyMs
    o.warehouse = encode_KlangCommLink_Feedback_Diagnostics_WarehouseStats(v.warehouse)
    o.soundlessVoices = v.soundlessVoices
    return o
}

fun decode_KlangCommLink_Feedback_Diagnostics(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.Diagnostics = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.Diagnostics(
    playbackId = o.playbackId,
    sampleRate = o.sampleRate,
    renderHeadroom = o.renderHeadroom,
    activeVoiceCount = o.activeVoiceCount,
    cylinders = wireDecodeList(o.cylinders) { w29 -> decode_KlangCommLink_Feedback_Diagnostics_CylinderState(w29) },
    backendNowMs = o.backendNowMs,
    baseLatencyMs = o.baseLatencyMs,
    outputDeviceLatencyMs = o.outputDeviceLatencyMs,
    outputLatencyMs = o.outputLatencyMs,
    warehouse = decode_KlangCommLink_Feedback_Diagnostics_WarehouseStats(o.warehouse),
    soundlessVoices = o.soundlessVoices,
)

fun encode_KlangCommLink_Feedback_Diagnostics_CylinderState(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.Diagnostics.CylinderState): dynamic {
    val o: dynamic = wireObj()
    o.id = v.id
    o.active = v.active
    return o
}

fun decode_KlangCommLink_Feedback_Diagnostics_CylinderState(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.Diagnostics.CylinderState = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.Diagnostics.CylinderState(
    id = o.id,
    active = o.active,
)

fun encode_KlangCommLink_Feedback_Diagnostics_WarehouseStats(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.Diagnostics.WarehouseStats): dynamic {
    val o: dynamic = wireObj()
    o.ringIdleBytes = v.ringIdleBytes
    o.ringIdleCount = v.ringIdleCount
    o.ringDirtyCount = v.ringDirtyCount
    o.ringAllocations = v.ringAllocations
    o.ringHits = v.ringHits
    o.ringFailures = v.ringFailures
    o.ringDropped = v.ringDropped
    o.ringSyncCleans = v.ringSyncCleans
    o.reverbIdleCount = v.reverbIdleCount
    o.reverbDirtyCount = v.reverbDirtyCount
    o.reverbAllocations = v.reverbAllocations
    o.reverbHits = v.reverbHits
    o.reverbFailures = v.reverbFailures
    o.reverbDropped = v.reverbDropped
    o.cylinderIdleCount = v.cylinderIdleCount
    o.cylinderAllocations = v.cylinderAllocations
    o.cylinderHits = v.cylinderHits
    o.cylinderDropped = v.cylinderDropped
    o.scratchCapacity = v.scratchCapacity
    o.scratchHighWater = v.scratchHighWater
    o.scratchLateAllocations = v.scratchLateAllocations
    o.scratchUnbalancedReleases = v.scratchUnbalancedReleases
    o.sampleBytes = v.sampleBytes
    o.sampleCount = v.sampleCount
    o.sampleAllocationFailures = v.sampleAllocationFailures
    o.droppedVoices = v.droppedVoices
    o.deniedRents = v.deniedRents
    return o
}

fun decode_KlangCommLink_Feedback_Diagnostics_WarehouseStats(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.Diagnostics.WarehouseStats = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.Diagnostics.WarehouseStats(
    ringIdleBytes = o.ringIdleBytes,
    ringIdleCount = o.ringIdleCount,
    ringDirtyCount = o.ringDirtyCount,
    ringAllocations = o.ringAllocations,
    ringHits = o.ringHits,
    ringFailures = o.ringFailures,
    ringDropped = o.ringDropped,
    ringSyncCleans = o.ringSyncCleans,
    reverbIdleCount = o.reverbIdleCount,
    reverbDirtyCount = o.reverbDirtyCount,
    reverbAllocations = o.reverbAllocations,
    reverbHits = o.reverbHits,
    reverbFailures = o.reverbFailures,
    reverbDropped = o.reverbDropped,
    cylinderIdleCount = o.cylinderIdleCount,
    cylinderAllocations = o.cylinderAllocations,
    cylinderHits = o.cylinderHits,
    cylinderDropped = o.cylinderDropped,
    scratchCapacity = o.scratchCapacity,
    scratchHighWater = o.scratchHighWater,
    scratchLateAllocations = o.scratchLateAllocations,
    scratchUnbalancedReleases = o.scratchUnbalancedReleases,
    sampleBytes = o.sampleBytes,
    sampleCount = o.sampleCount,
    sampleAllocationFailures = o.sampleAllocationFailures,
    droppedVoices = o.droppedVoices,
    deniedRents = o.deniedRents,
)

fun encode_KlangCommLink_Feedback_PlaybackAnchored(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.PlaybackAnchored): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.epochSec = v.epochSec
    return o
}

fun decode_KlangCommLink_Feedback_PlaybackAnchored(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.PlaybackAnchored = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.PlaybackAnchored(
    playbackId = o.playbackId,
    epochSec = o.epochSec,
)

fun encode_KlangCommLink_Feedback_RequestSample(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.RequestSample): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.req = encode_SampleRequest(v.req)
    return o
}

fun decode_KlangCommLink_Feedback_RequestSample(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.RequestSample = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.RequestSample(
    playbackId = o.playbackId,
    req = decode_SampleRequest(o.req),
)

fun encode_KlangCommLink_Feedback_SampleReceived(v: io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.SampleReceived): dynamic {
    val o: dynamic = wireObj()
    o.playbackId = v.playbackId
    o.req = encode_SampleRequest(v.req)
    return o
}

fun decode_KlangCommLink_Feedback_SampleReceived(o: dynamic): io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.SampleReceived = io.peekandpoke.klang.audio_bridge.infra.KlangCommLink.Feedback.SampleReceived(
    playbackId = o.playbackId,
    req = decode_SampleRequest(o.req),
)

